(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.attachCalloutBoxToDom = attachCalloutBoxToDom;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _initNav = require("../page/initNav.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalloutBox = _react2.default.createClass({
    displayName: "CalloutBox",


    propTypes: {
        titleHtml: _react.PropTypes.string,
        bodyHtml: _react.PropTypes.string,
        labelHtml: _react.PropTypes.string,
        expandable: _react.PropTypes.bool,
        fade: _react.PropTypes.bool,
        onAnimationFrame: _react.PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
        return {
            labelHtml: _react2.default.createElement(
                "h2",
                null,
                "Expandable Box"
            ),
            titleHtml: "",
            bodyHtml: "",
            expandable: true,
            onAnimationFrame: function onAnimationFrame() {}
        };
    },
    getInitialState: function getInitialState() {
        return {
            isOpen: false
        };
    },


    // on mount, hide/show the body immediately
    // (we can't do this in render because we need to animate it when the user
    // clicks the toggle button)
    componentDidMount: function componentDidMount() {
        var body = (0, _jquery2.default)(this.refs["body"]);
        (0, _jquery2.default)(body).css({ display: this.state.isOpen || !this.props.expandable || this.props.fade ? "block" : "none" });
        if (this.props.fade) {
            (0, _jquery2.default)(body).css({ height: "100px" });
        }
    },
    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
        // if the isOpen state changed
        if (prevState.isOpen !== this.state.isOpen) {

            var $body = (0, _jquery2.default)(this.refs["body"]);

            // slide the body up or down
            if (!this.state.isOpen) {
                $body.animate({ height: this.props.fade ? "100px" : "0px" }, { progress: this.props.onAnimationFrame });
            } else {
                $body.css("height", "auto").hide().slideDown({ progress: this.props.onAnimationFrame });
            }

            // scroll the body to the top of the box when it collapses
            (0, _initNav.scrollBodyTo)((0, _jquery2.default)(this.refs["container"]).offset().top - 16, 400);
        }

        if (this.props.expandable === false) {
            var _$body = (0, _jquery2.default)(this.refs["body"]);
            _$body.show();
        }
    },
    handleToggleClick: function handleToggleClick() {
        this.setState({ isOpen: !this.state.isOpen });
    },
    render: function render() {
        var _props = this.props,
            bodyHtml = _props.bodyHtml,
            titleHtml = _props.titleHtml,
            labelHtml = _props.labelHtml,
            expandable = _props.expandable;
        var isOpen = this.state.isOpen;


        var calloutBoxClasses = (0, _classnames2.default)("callout-box", {
            "is-expanded": isOpen
        });

        return _react2.default.createElement(
            "div",
            { className: calloutBoxClasses, ref: "container" },
            _react2.default.createElement(
                "div",
                { className: "callout-box__label-wrapper" },
                _react2.default.createElement("div", { className: "callout-box__label", dangerouslySetInnerHTML: { __html: labelHtml } })
            ),
            titleHtml && _react2.default.createElement("div", { className: "callout-box__title", dangerouslySetInnerHTML: { __html: titleHtml } }),
            _react2.default.createElement("div", { className: "callout-box__body", dangerouslySetInnerHTML: { __html: bodyHtml }, ref: "body" }),
            // expand collapse button
            expandable && _react2.default.createElement(
                "div",
                { className: "callout-box__toggle", onClick: this.handleToggleClick },
                isOpen ? "Close" : "Expand"
            )
        );
    }
});

exports.default = CalloutBox;

/**
 * grab the callout boxes in the dom and attach the react component
 * @param  {String} selector: jquery selector to find each element to attach to
 * @param  {Function} onAnimationFrame: function to be called on each tick while expanding/collapsing
 * @return {Nothing}
 *
 *  Example DOM structure
 *  <div class="js-expandable-box" [data-label="This is optional"]>
 *      <div class="js-title">Chicago’s South Side: Identifying Community Assets and Priorities to Study and Improve Urban Health</div>
 *      <div class="js-body">Suspendisse ex est, dapibus in commodo eget, <strong>pretium a enim.</strong> Nunc consequat nisl et sodales feugiat. Donec quis vulputate metus. Integer cursus lectus leo, in feugiat odio tincidunt et. Aliquam quam justo, efficitur id mi elementum, tempus fermentum ex. Sed vitae lacus aliquam, viverra velit vitae, egestas nulla. Morbi lobortis odio quis gravida hendrerit. Phasellus gravida, felis a posuere vestibulum, eros ipsum pellentesque velit, eu ornare eros tellus sed dolor. Nunc vitae bibendum nibh. Praesent lacinia augue ac lectus eleifend faucibus. Suspendisse ex est, dapibus in commodo eget, pretium a enim. Nunc consequat nisl et sodales feugiat. Donec quis vulputate metus. Integer cursus lectus leo, in feugiat odio tincidunt et. Aliquam quam justo, efficitur id mi elementum, tempus fermentum ex. Sed vitae lacus aliquam, viverra velit vitae, egestas nulla. Morbi lobortis odio quis gravida hendrerit. Phasellus gravida, felis a posuere vestibulum, eros ipsum pellentesque velit, eu ornare eros tellus sed dolor. Nunc vitae bibendum nibh. Praesent lacinia augue ac lectus eleifend faucibus. </div>
 *  </div>
 */

function attachCalloutBoxToDom(_ref) {
    var selector = _ref.selector,
        expandable = _ref.expandable,
        onAnimationFrame = _ref.onAnimationFrame;


    (0, _jquery2.default)(selector).each(function (i, el) {

        var labelHtml = (0, _jquery2.default)(el).find(".js-label").html() || "";
        var bodyHtml = (0, _jquery2.default)(el).find(".js-body").html() || "";
        var titleHtml = (0, _jquery2.default)(el).find(".js-title").html() || "";
        var isFaded = (0, _jquery2.default)(el).hasClass("fade");

        _reactDom2.default.render(_react2.default.createElement(CalloutBox, {
            titleHtml: titleHtml,
            bodyHtml: bodyHtml,
            labelHtml: labelHtml,
            expandable: expandable,
            fade: isFaded,
            onAnimationFrame: onAnimationFrame
        }), el);
    });
}

},{"../page/initNav.js":12,"classnames":"classnames","jquery":"jquery","react":"react","react-dom":"react-dom"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _munchSlopeChartData2 = require("./munchSlopeChartData.js");

var _munchSlopeChartData3 = _interopRequireDefault(_munchSlopeChartData2);

var _core = require("../../data/core.js");

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _React$PropTypes = _react2.default.PropTypes,
    shape = _React$PropTypes.shape,
    object = _React$PropTypes.object;


var filters = [{ name: "All", value: "all" }, { name: "Medicaid Expanded", value: "med-exp" }, { name: "Upward", value: "upward" }, { name: "Downward", value: "downward" }];

var padding = 20;

exports.default = _react2.default.createClass({
    displayName: "SlopeChart",


    propTypes: {
        data: shape({
            cleanData: object,
            indicators: object,
            locations: object
        })
    },

    getInitialState: function getInitialState() {
        return {
            selectedIndicatorId: core.overallIndicatorIds[0], // overall, etc
            leftLocations: [],
            rightLocations: [],
            locationsData: {},
            hoveredLocationId: null,
            selectedFilter: filters[0].value,

            // a flag to tell when something has changed that requires the svg lines to be recalculated
            // we'll use this to re-render the svg lines *only* once afterward
            shouldRecalculateLines: false,
            svgWidth: 0 // measured from DOM
        };
    },
    componentWillMount: function componentWillMount() {
        this.componentWillReceiveProps(this.props);
    },
    componentDidMount: function componentDidMount() {
        // re-render so the refs are populated
        this.forceUpdate();

        window.addEventListener("resize", this.calculateLineData);

        // Sometimes scroll bars pop in and out and we need to recalculate the positions
        window.addEventListener("scroll", this.calculateLineData);
    },
    componentWillUnmount: function componentWillUnmount() {
        window.removeEventListener("resize", this.calculateLineData);
        window.removeEventListener("scroll", this.calculateLineData);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.munchIndicatorData({ data: nextProps.data });
    },
    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {

        // calculate the svg data if the flag says so
        if (this.state.shouldRecalculateLines) {
            this.calculateLineData();
        }
    },


    /**
     * munch the data and set the state via setState
     * @param {object} obj.data
     *     Defaults to the data in this.props.  Caller can also pass other data (eg. nextData)
     * @param {object} obj.selectedIndicatorId
     *     Defaults to the selectedIndicatorId in this.state.
     *
     */
    munchIndicatorData: function munchIndicatorData(_ref) {
        var _ref$data = _ref.data,
            data = _ref$data === undefined ? this.props.data : _ref$data,
            _ref$selectedIndicato = _ref.selectedIndicatorId,
            selectedIndicatorId = _ref$selectedIndicato === undefined ? this.state.selectedIndicatorId : _ref$selectedIndicato;

        var _munchSlopeChartData = (0, _munchSlopeChartData3.default)(data, selectedIndicatorId),
            leftLocations = _munchSlopeChartData.leftLocations,
            rightLocations = _munchSlopeChartData.rightLocations,
            locationsData = _munchSlopeChartData.locationsData;

        // including selectedIndicatorId


        var nextState = { leftLocations: leftLocations, rightLocations: rightLocations, locationsData: locationsData, shouldRecalculateLines: true, selectedIndicatorId: selectedIndicatorId };

        this.setState(nextState);
    },


    // lineData calcualted after a render so we can read from the DOM
    // lineData will be added to each location in this.state.locationsData
    // used to draw the lines and calculate the closest line to the mouse
    calculateLineData: function calculateLineData() {
        var _this = this;

        var svgWidth = !this.svg ? 0 : (0, _jquery2.default)(this.svg).width();
        var lowestLocation = this.locations ? Math.max.apply(null, _ramda2.default.values(this.locations).map(function (l) {
            return (0, _jquery2.default)(l.left).position().top;
        })) : 0;
        var svgHeight = lowestLocation + 20;

        // R.map because this.state.locationsData is an object
        var locationsDataWithLineData = _ramda2.default.map(function (location) {

            if (!_this.locations || !_this.svg) {
                return null;
            }

            var centerY = function centerY(el) {
                return el.position().top + el.height() / 2;
            };

            var leftY = centerY((0, _jquery2.default)(_this.locations[location.data.orderData.left.drawLineFromId].left));
            var rightY = centerY((0, _jquery2.default)(_this.locations[location.data.orderData.right.drawLineFromId].right));

            var leftRank = location.data.years[0].rank;
            var rightRank = location.data.years[1].rank;

            var color = leftRank > rightRank ? "#7c7" : leftRank < rightRank ? "#c77" : "#999";

            return Object.assign({}, location, {
                lineData: { leftY: leftY, rightY: rightY, color: color }
            });
        }, this.state.locationsData);

        this.setState({
            locationsData: locationsDataWithLineData,
            svgHeight: svgHeight,
            svgWidth: svgWidth - 2 * padding,
            shouldRecalculateLines: false
        });
    },
    saveLocationRef: function saveLocationRef(side, locationId, el) {

        if (!el) {
            return;
        }

        if (!this.locations) {
            this.locations = {};
        }

        this.locations[locationId] = Object.assign({}, this.locations[locationId], _defineProperty({}, side, el));
    },
    handleLocationHover: function handleLocationHover(hoveredLocationId) {
        this.setState({
            hoveredLocationId: hoveredLocationId
        });
    },
    handleMedicaidChange: function handleMedicaidChange(event) {
        var selectedFilter = event.target.checked ? "med-exp" : "all";
        this.setState({ selectedFilter: selectedFilter });
    },
    handleIndicatorChange: function handleIndicatorChange(event) {
        this.munchIndicatorData({ selectedIndicatorId: event.target.value });
    },
    handleMouseMove: function handleMouseMove(e) {
        var _state = this.state,
            svgWidth = _state.svgWidth,
            hoveredLocationId = _state.hoveredLocationId,
            locationsData = _state.locationsData;

        var svgOffset = (0, _jquery2.default)(this.svg).offset();
        var y = e.pageY - svgOffset.top;
        var x = e.pageX - svgOffset.left;

        var closest = Object.keys(locationsData).reduce(function (closest, id) {

            var location = locationsData[id];
            var lineData = location.lineData;

            // inverse slope because 0 is at the top of the svg
            var slope = (lineData.rightY - lineData.leftY) / svgWidth;

            // y = mx + b
            var lineY = slope * x + lineData.leftY;
            var distance = Math.abs(lineY - y);

            return distance < closest.distance ? { distance: distance, id: location.id } : closest;
        }, { id: null, distance: Infinity });

        // don't update if it hasn't changed
        if (closest.id !== hoveredLocationId) {
            this.setState({
                hoveredLocationId: closest.id
            });
        }
    },
    drawTick: function drawTick(locationId, leftOrRight) {
        var _state2 = this.state,
            locationsData = _state2.locationsData,
            hoveredLocationId = _state2.hoveredLocationId;


        var location = locationsData[locationId];
        var lineData = location.lineData;

        // we won't have lineData the first render
        if (!lineData) {
            return;
        }

        var isHovered = location.id === hoveredLocationId;
        var orderData = leftOrRight === "left" ? location.data.orderData.left : location.data.orderData.right;

        var getLineVal = leftOrRight === "left" ? function (d) {
            return d.leftY;
        } : function (d) {
            return d.rightY;
        };

        var xStart = leftOrRight === "left" ? -12 : 12;
        var xEnd = leftOrRight === "left" ? -4 : 4;

        var offsetIncrement = (0, _jquery2.default)(this.locations[orderData.drawLineFromId].left).height();
        var yOffset = orderData.tieOffset * offsetIncrement - offsetIncrement * 1 / 2;

        if (orderData.isSingle || !orderData.hasTiedBefore) {
            return "";
        }

        return _react2.default.createElement("path", { key: locationId,
            transform: "translate(0," + getLineVal(lineData) + ")",
            d: "M" + xStart + ",7 l0," + yOffset + " l" + xEnd + ",0",
            fill: "none",
            stroke: isHovered ? "#3b3b3b" : "#ccc",
            strokeWidth: 1,
            style: {
                shapeRendering: "crispEdges"
            }
        });
    },
    render: function render() {
        var _this2 = this;

        var _state3 = this.state,
            leftLocations = _state3.leftLocations,
            rightLocations = _state3.rightLocations,
            locationsData = _state3.locationsData,
            hoveredLocationId = _state3.hoveredLocationId,
            svgWidth = _state3.svgWidth,
            svgHeight = _state3.svgHeight,
            selectedFilter = _state3.selectedFilter,
            selectedIndicatorId = _state3.selectedIndicatorId;


        var isHovered = function isHovered(location) {
            return location.id === hoveredLocationId;
        };

        var isRankDimmed = function isRankDimmed(leftOrRight, location) {
            var hoveredLocation = locationsData[hoveredLocationId];

            // if there is no hovered location, delegate to isLoactionDimmed
            if (!hoveredLocation) {
                return isLocationDimmed(location);
            }

            var yearIndex = (0, _munchSlopeChartData2.leftOrRightToIndex)(leftOrRight);

            var thisRank = location.data.years[yearIndex].rank;
            var hoveredRank = hoveredLocation.data.years[yearIndex].rank;

            return thisRank !== hoveredRank;
        };

        var isLocationDimmed = function isLocationDimmed(location) {

            // we won't have this until the second render
            if (!location.lineData) {
                return false;
            }

            // if something is hovered, this takes precedence
            if (hoveredLocationId !== null) {
                return !isHovered(location);
            }

            var lineData = location.lineData;

            // otherwise, check the filters
            return (
                // medicaid expanded only filter
                selectedFilter === "med-exp" && location.medicaidExpansion === false ||
                // upward filter
                selectedFilter === "upward" && (location.medicaidExpansion === false || lineData.leftY <= lineData.rightY)
                // downward filter
                || selectedFilter === "downward" && (location.medicaidExpansion === false || lineData.leftY >= lineData.rightY)
            );
        };

        var curveOffset = svgWidth * 0.2;

        var sortByHoveredLocationFirst = function sortByHoveredLocationFirst(id) {
            return id === hoveredLocationId ? 1 : 0;
        };

        return _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
                "div",
                { className: "slope-chart__indicator-selector" },
                _react2.default.createElement(
                    "select",
                    { name: "indicator", value: selectedIndicatorId, onChange: this.handleIndicatorChange },
                    core.overallIndicatorIds.map(function (id) {
                        return _react2.default.createElement(
                            "option",
                            { key: id, value: id },
                            _this2.props.data.indicators[id].shortName,
                            " "
                        );
                    })
                ),
                _react2.default.createElement(
                    "label",
                    { className: "input-checkbox" },
                    _react2.default.createElement("input", { type: "checkbox", onChange: this.handleMedicaidChange }),
                    _react2.default.createElement("span", null),
                    " Medicaid Expansion States ",
                    _react2.default.createElement("span", { className: "slope-chart__location-dot" })
                )
            ),
            _react2.default.createElement(
                "div",
                { className: "slope-chart" },
                _react2.default.createElement(
                    "div",
                    { className: "slope-chart__left", ref: function ref(el) {
                            return _this2.leftDiv = el;
                        } },
                    _react2.default.createElement(
                        "div",
                        { className: "slope-chart__column-title" },
                        "Baseline Rank"
                    ),
                    leftLocations.map(function (locationId) {
                        var location = locationsData[locationId];

                        var locationClasses = (0, _classnames2.default)("slope-chart__location", {
                            "is-location-dimmed": isLocationDimmed(location),
                            "is-rank-dimmed": isRankDimmed("left", location),
                            "is-hovered": isHovered(location),
                            "is-last-in-group": location.data.orderData.left.isLastInGroup,
                            "is-first-in-group": location.data.orderData.left.isFirstInGroup,
                            "has-tied-before": location.data.orderData.left.hasTiedBefore,
                            "has-tied-after": location.data.orderData.left.hasTiedAfter,
                            "is-tied": location.data.orderData.left.isTied,
                            "is-single": location.data.orderData.left.isSingle
                        });

                        return _react2.default.createElement(
                            "div",
                            { className: locationClasses,
                                key: location.abbreviation,
                                onMouseEnter: _this2.handleLocationHover.bind(null, location.id),
                                onMouseLeave: _this2.handleLocationHover.bind(null, null),
                                ref: function ref(el) {
                                    return _this2.saveLocationRef("left", location.id, el);
                                } },
                            _react2.default.createElement(
                                "span",
                                { className: "slope-chart__location-text" },
                                _react2.default.createElement(
                                    "span",
                                    { className: "slope-chart__location-name" },
                                    location.name
                                ),
                                _react2.default.createElement(
                                    "span",
                                    { className: "slope-chart__location-rank" },
                                    location.data.years[0].rank
                                )
                            )
                        );
                    })
                ),
                _react2.default.createElement(
                    "div",
                    { className: "slope-chart__lines" },
                    _react2.default.createElement(
                        "svg",
                        { height: svgHeight, ref: function ref(el) {
                                return _this2.svg = el;
                            }, onMouseMove: this.handleMouseMove, onMouseLeave: this.handleLocationHover.bind(null, null) },
                        _react2.default.createElement(
                            "g",
                            { className: "left-ticks", transform: "translate(" + padding + ", 0)" },
                            _ramda2.default.compose(_ramda2.default.map(function (locationId) {
                                return _this2.drawTick(locationId, "left");
                            }), _ramda2.default.sortBy(sortByHoveredLocationFirst))(leftLocations)
                        ),
                        _react2.default.createElement(
                            "g",
                            { transform: "translate(" + padding + ", 0)" },
                            leftLocations.map(function (locationId) {
                                if (!_this2.locations || !_this2.svg) {
                                    return null;
                                }

                                var location = locationsData[locationId];
                                var lineData = location.lineData;

                                // we won't have lineData the first render
                                if (!lineData) {
                                    return;
                                }

                                var opacity = isLocationDimmed(location) ? 0.2 : 1;

                                return _react2.default.createElement("path", {
                                    key: location.id,
                                    d: "\n                                                M0," + lineData.leftY + "\n                                                C" + curveOffset + "," + lineData.leftY + "\n                                                 " + (svgWidth - curveOffset) + "," + lineData.rightY + "\n                                                 " + svgWidth + "," + lineData.rightY,
                                    stroke: lineData.color,
                                    strokeWidth: "2",
                                    opacity: opacity,
                                    fill: "none"
                                });
                            })
                        ),
                        _react2.default.createElement(
                            "g",
                            { className: "right-ticks", transform: "translate(" + (svgWidth + padding) + ", 0)" },
                            _ramda2.default.compose(_ramda2.default.map(function (locationId) {
                                return _this2.drawTick(locationId, "right");
                            }), _ramda2.default.sortBy(sortByHoveredLocationFirst))(rightLocations)
                        )
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "slope-chart__right" },
                    _react2.default.createElement(
                        "div",
                        { className: "slope-chart__column-title" },
                        "2017 Scorecard Rank"
                    ),
                    rightLocations.map(function (locationId) {
                        var location = locationsData[locationId];

                        var locationClasses = (0, _classnames2.default)("slope-chart__location", {
                            "is-location-dimmed": isLocationDimmed(location),
                            "is-rank-dimmed": isRankDimmed("right", location),
                            "is-hovered": isHovered(location),
                            "is-last-in-group": location.data.orderData.right.isLastInGroup,
                            "is-first-in-group": location.data.orderData.right.isFirstInGroup,
                            "has-tied-before": location.data.orderData.right.hasTiedBefore,
                            "has-tied-after": location.data.orderData.right.hasTiedAfter,
                            "is-tied": location.data.orderData.right.isTied,
                            "is-single": location.data.orderData.right.isSingle
                        });

                        return _react2.default.createElement(
                            "div",
                            { className: locationClasses,
                                key: location.abbreviation,
                                onMouseEnter: _this2.handleLocationHover.bind(null, location.id),
                                onMouseLeave: _this2.handleLocationHover.bind(null, null),
                                ref: function ref(el) {
                                    return _this2.saveLocationRef("right", location.id, el);
                                } },
                            _react2.default.createElement(
                                "span",
                                { className: "slope-chart__location-text" },
                                _react2.default.createElement(
                                    "span",
                                    { className: "slope-chart__location-rank" },
                                    location.data.years[1].rank
                                ),
                                _react2.default.createElement(
                                    "span",
                                    { className: "slope-chart__location-name" },
                                    location.name
                                )
                            ),
                            _react2.default.createElement("span", { className: (0, _classnames2.default)("slope-chart__location-dot", {
                                    "is-hidden": !location.medicaidExpansion
                                }) })
                        );
                    })
                )
            ),
            _react2.default.createElement(
                "p",
                { className: "note" },
                _react2.default.createElement("span", { className: "slope-chart__location-dot" }),
                " indicates states that expanded Medicaid under the Affordable Care Act as of January 1, 2015."
            )
        );
    }
});

},{"../../data/core.js":5,"./munchSlopeChartData.js":3,"classnames":"classnames","jquery":"jquery","ramda":"ramda","react":"react"}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.leftOrRightToIndex = undefined;
exports.default = munchSlopeChartData;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _core = require("../../data/core.js");

var core = _interopRequireWildcard(_core);

var _d = require("d3");

var _d2 = _interopRequireDefault(_d);

var _compare = require("../../data/compare.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var leftOrRightToIndex = exports.leftOrRightToIndex = function leftOrRightToIndex(leftOrRight) {
    return leftOrRight === "left" ? 0 // location.year[0]
    : leftOrRight === "right" ? 1 // location.year[1]
    : console.error("leftOrRight should be \"left\" or \"right\" but was given " + leftOrRight + "!");
};

function munchSlopeChartData(_ref, selectedIndicatorId) {
    var cleanData = _ref.cleanData,
        indicators = _ref.indicators,
        locations = _ref.locations;


    /* validate selectedIndicatorId */
    if (_ramda2.default.not(_ramda2.default.contains(selectedIndicatorId, core.overallIndicatorIds))) {
        console.error("invalid selectedIndicatorId: ", selectedIndicatorId);
        return;
    }

    var states = _ramda2.default.filter(core.notUsLocation, locations); // keep only states


    /* helper functions */

    // get the selected indicator data for the given location
    var getIndicatorData = function getIndicatorData(locationId) {
        return cleanData[selectedIndicatorId][locationId];
    };
    var getRankChange = function getRankChange(locationData) {
        return locationData.years[0].rank - locationData.years[1].rank;
    };

    /* make arrays of ID's of the left and right ordered by rank */

    // make a compare function for the given year (0 or 1)
    var compareRank = function compareRank(leftOrRight) {
        var yearIndex = leftOrRightToIndex(leftOrRight);
        return (0, _compare.compare)(function (location) {
            return getIndicatorData(location.id).years[yearIndex].rank;
        }, _compare.ascending);
    };

    // @param {String} leftOrRight : "left" or "right"
    var processLocations = function processLocations(leftOrRight) {
        return _ramda2.default.compose(_ramda2.default.map(_ramda2.default.prop("id")), _ramda2.default.sort(compareRank(leftOrRight)), _ramda2.default.values // transform object > array
        )(states);
    };

    // make arrays or location IDs ordered by year ranks
    var leftLocations = processLocations("left");

    var rightLocations = processLocations("right");

    /* munch indicator data to make locationsData */

    /**
     * areSameRank: look at the location before and after to see if they have the same rank
     * @param  {String} leftOrRight : "left" or "right"
     * @param  {Object} locationId1 : ID of a location
     * @param  {Object} locationId2 : ID of a location
     * @return {Boolean}  True if location1 and location2 have the same rank
     *                     at the given year (leftOrRight)
     */
    var areSameRank = _ramda2.default.curry(function (leftOrRight, locationId1, locationId2) {

        var l1 = getIndicatorData(locationId1);
        var l2 = getIndicatorData(locationId2);

        if (!l1 || !l2) {
            return false;
        }

        var yearIndex = leftOrRightToIndex(leftOrRight);

        var rank1 = l1.years[yearIndex].rank;
        var rank2 = l2.years[yearIndex].rank;

        return rank1 === rank2;
    });

    /**
     *  process the locations for left and right, using the locationsData
     *  @param {Object} location: { id, name, abbreviation, medicaidExpansion }
     *  @return {Array} : arrays of objects like this:
     *  {
     *      hasTiedAfter: Boolean,
     *      hasTiedBefore: Boolean,
     *      drawLineFromId: Number: if this location is tied with one or more above,
     *          this will be the id of that one on top. ie. from where the
     *          line for this location should be drawn
     *  }
     */
    var getOrderData = function getOrderData(leftOrRight, location) {

        // array of id's either the leftLocations or rightLocations
        var orderedStates = leftOrRight === "left" ? leftLocations : leftOrRight === "right" ? rightLocations : console.error("leftOrRight should be \"left\" or \"right\" but was given " + leftOrRight + "!");

        var findTopTiedId = function findTopTiedId(j) {

            var currentLocationId = orderedStates[j];
            var previousLocationId = orderedStates[j - 1];

            // if j-1 is a valid index and it's the same rank, recurse
            if (previousLocationId && areSameRank(leftOrRight, currentLocationId, previousLocationId)) {
                return findTopTiedId(j - 1);
            } else {
                // otherwise, this is the top, return the id
                return currentLocationId;
            }
        };

        var index = _ramda2.default.findIndex(_ramda2.default.equals(location.id), orderedStates);
        var firstIndexOfRank = _ramda2.default.findIndex(areSameRank(leftOrRight, location.id), orderedStates);

        var hasTiedBefore = areSameRank(leftOrRight, orderedStates[index], orderedStates[index - 1]);
        var hasTiedAfter = areSameRank(leftOrRight, orderedStates[index], orderedStates[index + 1]);
        var isLastInGroup = hasTiedBefore && !hasTiedAfter;
        var isFirstInGroup = !hasTiedBefore && hasTiedAfter;
        var isTied = hasTiedAfter || hasTiedBefore;
        var isSingle = !hasTiedAfter && !hasTiedBefore;
        var tieOffset = index - firstIndexOfRank;

        return {
            hasTiedBefore: hasTiedBefore, hasTiedAfter: hasTiedAfter, isLastInGroup: isLastInGroup, isFirstInGroup: isFirstInGroup, isTied: isTied, isSingle: isSingle, tieOffset: tieOffset,
            drawLineFromId: findTopTiedId(index)
        };
    };

    // augment the location data
    var munchIndicatorData = function munchIndicatorData(location) {

        var locationData = getIndicatorData(location.id);

        return {
            // calculate change in rank
            change: {
                rank: getRankChange(locationData)
            },
            years: locationData.years,
            orderData: {
                left: getOrderData("left", location),
                right: getOrderData("right", location)
            }
        };
    };

    var locationsData = _ramda2.default.compose(_ramda2.default.map(function (l) {
        return _ramda2.default.merge(l, { data: munchIndicatorData(l) });
    }))(states);

    return {
        leftLocations: leftLocations,
        rightLocations: rightLocations,
        locationsData: locationsData
    };
}

},{"../../data/compare.js":4,"../../data/core.js":5,"d3":"d3","ramda":"ramda"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.compare = exports.descending = exports.ascending = exports.composeComparators = undefined;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _core = require("./core.js");

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Comparators
var composeComparators = exports.composeComparators = function composeComparators(comparators) {
    return function (a, b) {
        core;
        return comparators.reduce(function (prevResult, c) {
            return prevResult !== 0 ? prevResult : c(a, b);
        }, 0);
    };
};

var ascending = exports.ascending = _ramda2.default.lt;

var descending = exports.descending = _ramda2.default.gt;

var compare = exports.compare = _ramda2.default.curry(function (f, compareOp) {
    return _ramda2.default.comparator(function (a, b) {
        return compareOp(f(a), f(b));
    });
});

},{"./core.js":5,"ramda":"ramda"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.indicatorHasHistoricalData = exports.formatValue = exports.latestYearValue = exports.getData = exports.getChangeStatus = exports.overallIndicatorChangeStatus = exports.getChange = exports.getOverallIndicatorChange = exports.dataPointOrderByStatus = exports.status = exports.statusOrder = exports.directionCorrectedPercentChange = exports.magnitudeOfChange = exports.hasChangeData = exports.notUsLocation = exports.isUsLocation = exports.lowerIsBetter = exports.isNotOverallIndicator = exports.isOverallIndicator = exports.overallIndicatorIds = exports.dimensionNames = undefined;
exports.calculateDifferenceDescription = calculateDifferenceDescription;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _d = require("d3");

var _d2 = _interopRequireDefault(_d);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Dimension
var dimensionNames = exports.dimensionNames = {
    "ACCESS": "Access and Affordability",
    "QUALITY": "Prevention and Treatment",
    "USE": "Avoidable Hospital Use and Costs",
    "LIVES": "Healthy Lives"
};

// Indicator
var overallIndicatorIds = exports.overallIndicatorIds = ["OVERALL", "a100", "q100", "u100", "h100"];

var isOverallIndicator = exports.isOverallIndicator = function isOverallIndicator(ind) {
    return _ramda2.default.contains(ind.id, overallIndicatorIds);
};

var isNotOverallIndicator = exports.isNotOverallIndicator = _ramda2.default.complement(isOverallIndicator);

var lowerIsBetter = exports.lowerIsBetter = function lowerIsBetter(ind) {
    return ind.direction === "Low";
};

// Location

var isUsLocation = exports.isUsLocation = _ramda2.default.propEq("id", 0);

var notUsLocation = exports.notUsLocation = _ramda2.default.complement(isUsLocation);

// Data point
var hasChangeData = exports.hasChangeData = function hasChangeData(dp) {
    return dp.change && !_ramda2.default.isNil(dp.change.delta);
};

var magnitudeOfChange = exports.magnitudeOfChange = function magnitudeOfChange(dp) {
    return !hasChangeData(dp) ? 0 : Math.abs(dp.change.delta / dp.years[0].value);
};

var directionCorrectedPercentChange = exports.directionCorrectedPercentChange = function directionCorrectedPercentChange(ind, dp) {
    return magnitudeOfChange(dp) * (lowerIsBetter(ind) ? -1 : 1);
};

var statusOrder = exports.statusOrder = { "worse": 0, "steady": 1, "improved": 2 };

var status = exports.status = function status(dp) {
    return dp.change.improved || "steady";
};

var dataPointOrderByStatus = exports.dataPointOrderByStatus = _ramda2.default.compose(_ramda2.default.prop(_ramda2.default.__, statusOrder), status);

var getOverallIndicatorChange = exports.getOverallIndicatorChange = function getOverallIndicatorChange(dp) {
    return dp.years[0].rank - dp.years[1].rank;
};

var getChange = exports.getChange = _ramda2.default.curry(function (ind, dp) {
    return isOverallIndicator(ind) ? getOverallIndicatorChange(dp) : dp.change.delta;
});

var overallIndicatorChangeStatus = exports.overallIndicatorChangeStatus = function overallIndicatorChangeStatus(dp) {
    var change = getOverallIndicatorChange(dp);
    return change > 0 ? "improved" : change < 0 ? "worse" : "steady";
};

var getChangeStatus = exports.getChangeStatus = _ramda2.default.curry(function (ind, dp) {
    return isOverallIndicator(ind) ? overallIndicatorChangeStatus(dp) : dp.change.improved;
});

var getData = exports.getData = _ramda2.default.curry(function (ind, year, dp) {
    return isOverallIndicator(ind) ? dp.years[year].rank : dp.years[year].value;
});

var latestYearValue = exports.latestYearValue = function latestYearValue(dp) {
    return dp.years[1].value;
};

function formatNumberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

var formatValue = exports.formatValue = _ramda2.default.curry(function (ind, value, sup) {
    if (ind.dataType === "percent") {
        return value + (sup ? "<sup>%</sup>" : "%");
    } else if (ind.dataType === "dollars") {
        return (sup ? "<sup>$</sup>" : "$") + formatNumberWithCommas(value);
    } else if (ind.dataType === "rank") {
        return (sup ? "<sup>#</sup>" : "#") + value;
    } else {
        return value;
    }
});

var indicatorHasHistoricalData = exports.indicatorHasHistoricalData = _ramda2.default.curry(function (data, ind) {
    return _ramda2.default.any(function (d) {
        return !_ramda2.default.isNil(d.years[0].value);
    }, _ramda2.default.values(data[ind.id]));
});

function calculateDifferenceDescription(data) {
    var max = _d2.default.max(data),
        min = _d2.default.min(data);

    var diffRate = max / min;

    if (diffRate < 2) {
        return Math.round((diffRate - 1) * 100) + "%";
    }

    return Math.round(diffRate) + "x";
}

},{"d3":"d3","ramda":"ramda"}],6:[function(require,module,exports){
"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _initPage = require("./page/initPage.js");

var _initPage2 = _interopRequireDefault(_initPage);

var _locationOverall = require("./viz/location-overall.js");

var _locationOverall2 = _interopRequireDefault(_locationOverall);

var _indicatorOverall = require("./viz/indicator-overall.js");

var _indicatorOverall2 = _interopRequireDefault(_indicatorOverall);

var _common = require("./page/common.js");

var _typeAhead = require("./page/typeAhead.js");

var _SlopeChart = require("./components/SlopeChart/SlopeChart.jsx");

var _SlopeChart2 = _interopRequireDefault(_SlopeChart);

require("./sniff.min.js");

var _loadVizData = require("./viz/loadVizData.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// add's UA info to html class (needed for iPad, see initPage.js)
(0, _loadVizData.loadVizData)().then(function (json) {
    var cleanData = json.cleanData,
        locations = json.locations,
        indicators = json.indicators,
        zips = json.zips;


    var states = _ramda2.default.filter(function (l) {
        return l.abbreviation !== "US";
    }, locations);

    /* slope chart */
    _reactDom2.default.render(_react2.default.createElement(_SlopeChart2.default, { data: { cleanData: cleanData, locations: locations, indicators: indicators } }), document.querySelector(".js-viz-slope-chart"));

    /* location overall */
    var locationOverallSelector = ".js-viz-location-overall";

    var locationOverall = (0, _locationOverall2.default)({
        selector: locationOverallSelector,
        width: (0, _jquery2.default)(locationOverallSelector).width(),
        height: 550,
        locations: states, indicators: indicators, cleanData: cleanData,
        onUnlock: function onUnlock() {
            // clear the typeahead when the active location is unlocked
            locationOverallTypeAhead.setValue("");
        }
    });

    _common.resize$.onValue(function (e) {
        locationOverall.setWidth((0, _jquery2.default)(locationOverallSelector).width());
    });

    // location overall typeahead
    var locationOverallTypeAhead = (0, _typeAhead.createTypeAhead)(".js-viz-location-overall__typeahead .typeahead", "name", (0, _typeAhead.zipHrrSource)(states, zips), function (hrr) {
        locationOverall.setActiveLocation(hrr.id);
    });

    // after the viz's are done, force a reflow so the sticky's are correct
    _common.reflow$.emit("viz's loaded");
});

/** initialize all the page scripts for navigation and sticky vizs, etc **/
(0, _initPage2.default)();

// cloak hides all the content. now that we've done all our layout crunching,
// show the content
(0, _jquery2.default)("body").removeClass("cloak");

},{"./components/SlopeChart/SlopeChart.jsx":2,"./page/common.js":9,"./page/initPage.js":13,"./page/typeAhead.js":15,"./sniff.min.js":16,"./viz/indicator-overall.js":20,"./viz/loadVizData.js":21,"./viz/location-overall.js":22,"jquery":"jquery","ramda":"ramda","react":"react","react-dom":"react-dom"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var emitter;
    var stream = _kefir2.default.stream(function (_emitter) {
        emitter = _emitter;
        return function unsubscribe() {
            emitter = undefined;
        };
    });

    stream.emit = function (x) {
        emitter && emitter.emit(x);
        return this;
    };

    stream.error = function (x) {
        emitter && emitter.error(x);
        return this;
    };

    stream.end = function () {
        emitter && emitter.end();
        return this;
    };

    stream.emitEvent = function (x) {
        emitter && emitter.emitEvent(x);
        return this;
    };

    return stream.setName("emitter");
};

var _kefir = require("kefir");

var _kefir2 = _interopRequireDefault(_kefir);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"kefir":"kefir"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addBreakpointHandlers;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _common = require("./common.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* NOTE: css has breakpoints in scss/_breakpoints.scss */

// page width
var BREAKPOINT_SMALL = 750;
var BREAKPOINT_MEDIUM = 900;

// convert the resize$ stream to a stream of width values
var windowWidth$ = (0, _common.toPropertyFromResize)(function (e) {
    return (0, _jquery2.default)(window).width();
})
// convert the width to "small" or "large"
.map(function (width) {
    return width < BREAKPOINT_SMALL ? "small" : width < BREAKPOINT_MEDIUM ? "medium" : "large";
})
// only emit new values if it's changed
.skipDuplicates();

function addBreakpointHandlers(_ref) {
    var _ref$onLarge = _ref.onLarge,
        onLarge = _ref$onLarge === undefined ? function () {} : _ref$onLarge,
        _ref$onMedium = _ref.onMedium,
        onMedium = _ref$onMedium === undefined ? function () {} : _ref$onMedium,
        _ref$onSmall = _ref.onSmall,
        onSmall = _ref$onSmall === undefined ? function () {} : _ref$onSmall;


    windowWidth$.onValue(function (width) {

        if (width === "small") {
            onSmall();
        } else if (width === "medium") {
            onMedium();
        } else {
            onLarge();
        }
    });
}

},{"./common.js":9,"jquery":"jquery"}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.scroll$ = exports.resize$ = exports.reflow$ = undefined;
exports.toPropertyFromResize = toPropertyFromResize;
exports.createPositionStream = createPositionStream;

var _kefir = require("kefir");

var _kefir2 = _interopRequireDefault(_kefir);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _KefirEmitter = require("./Kefir.emitter.js");

var _KefirEmitter2 = _interopRequireDefault(_KefirEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// imperative stream so we can trigger the resize properties to recalculate
// when there is a reflow in the page. Without this, the measurements will
// become stale and wrong.
// (is there a better way to do this?)
var reflow$ = exports.reflow$ = (0, _KefirEmitter2.default)();

// stream of window resize events
var resize$ = exports.resize$ = _kefir2.default.fromEvents(window, "resize");

// property stream of pageYOffset
var scroll$ = exports.scroll$ = _kefir2.default.fromEvents(window, "scroll").map(function (e) {
    return window.pageYOffset;
}).toProperty(function (e) {
    return window.pageYOffset;
});

/**
 * A common pattern to create a property based on the resize$ and reflow$ streams
 * @param  {Function} fn: function that does some measuring
 * @return {Stream}
 */
function toPropertyFromResize(fn) {
    return _kefir2.default.merge([resize$, reflow$]).map(fn) // measure when the window is resized
    .toProperty(fn); // measure initially
}

/**
 * createPositionStream.  create a stream of measurements to be used by sticky watchers
 * @param  {Element} element: node (use document.querySelector)
 * @return {Stream} stream of the positions
 */
function createPositionStream(_ref) {
    var element = _ref.element;


    // the container element
    var parent = element.parentNode;

    // measure the element's position relative to the document
    var measureElement = function measureElement() {
        var elementBB = element.getBoundingClientRect();

        return {
            height: elementBB.height,
            width: elementBB.width,
            top: elementBB.top + window.pageYOffset
        };
    };

    // elementMeasures stream
    var elementMeasures$ = toPropertyFromResize(measureElement);

    // parent's measurements, relative to the document
    var measureParent = function measureParent() {
        var parentBB = parent.getBoundingClientRect();

        return {
            top: parentBB.top + window.pageYOffset,
            // $(window).width() does NOT include the scrollbar (important for windows machines)
            right: (0, _jquery2.default)(window).width() - parentBB.right + window.pageXOffset,
            bottom: parentBB.bottom + window.pageYOffset,
            left: parentBB.left + window.pageXOffset,
            width: parentBB.width,
            height: parentBB.height,
            // text is on the right, viz is on the left
            vizOnLeft: (0, _jquery2.default)(parent).hasClass("viz-section--viz-left")
        };
    };

    // parentMeasures stream
    var parentMeasures$ = toPropertyFromResize(measureParent);

    // combine the streams to calculate where the sticky element should be
    var position$ = _kefir2.default.combine([scroll$, elementMeasures$, parentMeasures$], function (scroll, elementMeasures, parentMeasures) {

        return {
            scroll: scroll,
            parentMeasures: parentMeasures,
            elementMeasures: elementMeasures
        };
    });

    return position$;
}

},{"./Kefir.emitter.js":7,"jquery":"jquery","kefir":"kefir"}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createModal;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * create a model with of the given html
 * @param  {String} html: html to be put in the popup
 * @param  {Number} aspectRatio: a number of width/height.  eg. .75 would be 3/4
 * @return {Object} {
 *     {Function} removeModal: close the modal
 * }
 */
function createModal(_ref) {
    var _ref$html = _ref.html,
        html = _ref$html === undefined ? "" : _ref$html,
        aspectRatio = _ref.aspectRatio;


    var $background = (0, _jquery2.default)("<div>").addClass("modal-background").on("click", removeModal);

    var $popup = (0, _jquery2.default)("<div>").addClass("modal-popup")
    // prevent background click from firing
    .on("click", function (e) {
        return e.stopPropagation();
    });

    var $xDiv = (0, _jquery2.default)("<div>").addClass("modal-popup__close").html("<svg class='svg-x'> <use xlink:href='img/svg-sprite.svg#x'></use> </svg>").on("click", removeModal);

    var $html = (0, _jquery2.default)("<div>").addClass("modal-html");

    $popup.append($xDiv).append($html);

    $background.append($popup);
    (0, _jquery2.default)("body").append($background);

    // re-render on resize so we can do the aspect ratio calculations again
    (0, _jquery2.default)(window).on("resize", render);

    // close the model when esc is pressed
    (0, _jquery2.default)(document).on("keyup", handleKeyPress);
    function handleKeyPress(e) {
        if ((e.which || e.charCode || e.keyCode) === 27) {
            removeModal();
        }
    }

    // render the first time
    render();

    // render the html and position the popup
    function render() {

        // reset some stuff
        $background.addClass("is-hidden");
        $popup.height("auto");
        $popup.width("auto");

        // populate the html
        $html.html(html.html());

        // adjust the aspect ratio and fade in
        function finish() {
            var width = $popup.outerWidth();
            var height = $popup.outerHeight();

            // adjust the popup to be be 4:3 aspect ratio
            if (typeof aspectRatio === "number") {
                if (height > width * aspectRatio) {
                    $popup.height(width * aspectRatio);
                    $popup.width(width);
                } else {
                    $popup.height(height);
                    $popup.width(height * (1 / aspectRatio));
                }
            }

            $background.removeClass("is-hidden");
        }

        // wait for the image to load to measure if needed
        // otherwise, the width/height measurements won't be accurate.
        var images = $html.find("img");
        if (images.length) {
            images.on("load", finish);
        } else {
            finish();
        }
    }

    // remove the modal and clean up event listeners
    function removeModal() {

        $background.addClass("is-hidden");

        // when the transition finishes, remove the popup from the DOM
        $background.on("transitionend", function () {
            $background.remove();
        });
        (0, _jquery2.default)(document).off("keyup", handleKeyPress);
        (0, _jquery2.default)(window).off("resize", removeModal);
    }

    // external api
    return {
        removeModal: removeModal
    };
}

},{"jquery":"jquery"}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createPopup;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _calculatePopupOffsets = require("../utils/calculatePopupOffsets.js");

var _calculatePopupOffsets2 = _interopRequireDefault(_calculatePopupOffsets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_jquery2.default.extend(_jquery2.default.easing, {
    easeInOutCubic: function easeInOutCubic(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t + 2) + b;
    }
});

/**
 * creates a popup and injects it in to the document.
 * @param  {String} title : title of the popup, optional
 * @param  {String} html : content of the popup as html
 * @param  {Number} top  : top position relative to the document
 * @param  {Number} left : left position relative to the document
 * @param  {Number} offset : a vertical or horizonal distance from the top/left the triangle should point
 *                           depending on if the triangle is top/bottom or left/right
 * @param  {String} container : a selector of the container in which to inject the popup
 * @param  {String} triangle : "top", "right", "bottom", or "left"
 * @param  {Boolean} flipToContain: will flip the popup if it goes outside the parent container
 * @param  {Boolean} closeBtn : if the X should be shown.  If not, the popup with not have pointer events
 *                              this is useful for popups on hover that shouldn't fire mouseenter/leave
 * @param  {Boolean} isHidden: Whether or not the popup is visible.
 * @return {Object} {
 *     {Function} hidePopup   : will set isHidden to true
 *     {Function} removePopup : will remove the popup from the DOM),
 *     {Function} setState : pass an object with any keys from above to update the popup.
 * }
 */
function createPopup(initialState) {

    // defaults, and this object will hold the previous state after setState
    var prevState = {
        title: "",
        html: "",
        top: 0,
        left: 0,
        width: "",
        offset: 0,
        container: "body",
        triangle: "bottom",
        closeBtn: true,
        isHidden: false,
        flipToContain: false
    };

    var state = Object.assign({}, prevState, initialState);

    function setState(newState) {

        // copy the old state into prevState
        prevState = Object.assign({}, state);

        Object.assign(state, newState);

        // console.log(state);

        render();
    }

    // initialize popup
    // always start hidden so it can animate in
    var $popup = (0, _jquery2.default)("<div class='popup'>").css({
        "opacity": 0,
        "width": state.width,
        "transform": "scale(0.89)",
        "pointer-events": state.closeBtn ? "auto" : "none"
    });
    var $titleDiv = (0, _jquery2.default)("<div>").addClass("popup__title");
    var $triangleDiv = (0, _jquery2.default)("<div>").addClass("popup__triangle");
    var $content = (0, _jquery2.default)("<div>").addClass("popup__content");

    // attach the close button if we're supposed to
    if (state.closeBtn) {
        var $xDiv = (0, _jquery2.default)("<div>").addClass("popup__x-icon").html("<svg class='svg-x'> <use xlink:href='img/svg-sprite.svg#x'></use> </svg>").on("click", removePopup);
        $popup.append($xDiv);

        window.addEventListener("click", handleClickAway, true);
        window.addEventListener("touchstart", handleClickAway, true);
        window.addEventListener("resize", handleClickAway, true);
        window.addEventListener("keyup", escListener, true);
    }

    $popup.append($titleDiv);
    $popup.append($triangleDiv);
    $popup.append($content);

    (0, _jquery2.default)(state.container).append($popup);

    // if the user clicked outside of the popup, close it
    function handleClickAway(e) {
        var inPopup = (0, _jquery2.default)(e.target).closest(".popup").length;
        if (!inPopup) {
            removePopup();
        }
    }

    function escListener(e) {
        if ((e.which || e.charCode || e.keyCode) === 27) {
            removePopup();
        }
    }

    function hidePopup() {

        window.removeEventListener("click", handleClickAway, true);
        window.removeEventListener("touchstart", handleClickAway, true);
        window.removeEventListener("resize", handleClickAway, true);
        window.removeEventListener("keyup", escListener, true);

        // only re-render if we need to
        if (state.isHidden !== true) {
            // will kick of the transition
            setState({
                isHidden: true
            });
        }
    }

    function removePopup() {

        // first close it
        hidePopup();

        // when the transition finishes, remove the popup from the DOM
        $popup.on("transitionend", function () {
            $popup.remove();
        });
    }

    // render the first time
    render();

    function render() {
        var top = state.top,
            left = state.left,
            offset = state.offset,
            triangle = state.triangle,
            isHidden = state.isHidden,
            html = state.html,
            title = state.title,
            flipToContain = state.flipToContain;

        // update the content before calculating the offsets

        $content.html(html);
        $titleDiv.html(title);

        var offsets = (0, _calculatePopupOffsets2.default)({
            popup: $popup.get(0),
            triangleSize: $triangleDiv.outerHeight(),
            top: top, left: left, offset: offset, triangle: triangle, flipToContain: flipToContain
        });

        // if the popup was hidden, we want to place it where it needs to be
        // the update will fade it in
        // enter - put it in place before transitioning in
        if (prevState.isHidden && !isHidden) {
            $popup.css({
                "top": offsets.popupTop + "px",
                "left": offsets.popupLeft + "px"
            });
        }

        $popup
        // .stop().animate({
        .css({
            opacity: isHidden ? 0 : 1,
            transform: isHidden ? "scale(0.9)" : "scale(1)",
            top: offsets.popupTop,
            left: offsets.popupLeft,
            width: state.width
        }, 250, "easeInOutCubic").removeClass(function (index, css) {
            return (css.match(/\bis-triangle-\S+/g) || []).join(" ");
        }).addClass("is-triangle-" + offsets.triangleSide).toggleClass("popup--hidden", isHidden);

        // adjust the triangle
        $triangleDiv.css({
            "transform": offsets.triangleSide === "top" || offsets.triangleSide === "bottom" ? "translateX(" + offsets.triangleOffset + "px)" // top/bottom
            : "translateY(" + offsets.triangleOffset + "px)" // left/right
        });

        $popup.toggleClass("no-title", !title);
    }

    // external api
    return {
        setState: setState,
        hidePopup: hidePopup,
        removePopup: removePopup
    };
}

},{"../utils/calculatePopupOffsets.js":17,"jquery":"jquery"}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.scrollBodyTo = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.measureNav = measureNav;
exports.default = initNav;

var _kefir = require("kefir");

var _kefir2 = _interopRequireDefault(_kefir);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _KefirEmitter = require("./Kefir.emitter.js");

var _KefirEmitter2 = _interopRequireDefault(_KefirEmitter);

var _common = require("./common.js");

var _addBreakpointHandlers = require("./addBreakpointHandlers.js");

var _addBreakpointHandlers2 = _interopRequireDefault(_addBreakpointHandlers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// measure the height of the nav including padding
function measureNav() {
    return (0, _jquery2.default)("nav").outerHeight();
}

/**
 * Observe the positions stream and update the nav to make it sticky
 * @param  {Element} element:
 * @param  {Number} topOffset: amount of space from the top of the
 *                             screen to place the sticky nav
 * @return {Nothing}
 */
function attachStickyWatcherToNav(_ref) {
    var element = _ref.element;


    var position$ = (0, _common.createPositionStream)({ element: element });

    // stream of true/false of whether or not the nav should be sticky
    var isSticky$ = (0, _KefirEmitter2.default)();

    position$
    // only do this if it's supposed to be sticky
    .filterBy(isSticky$)
    // update the dom with our measurements when either of those streams emit
    .onValue(function (_ref2) {
        var scroll = _ref2.scroll,
            parentMeasures = _ref2.parentMeasures,
            elementMeasures = _ref2.elementMeasures;


        var pm = parentMeasures;
        var em = elementMeasures;

        var shouldFix = scroll > em.top;

        (0, _jquery2.default)(element).find("nav").css({
            "position": shouldFix ? "fixed" : "absolute",
            "top": shouldFix ? 0 : "auto",
            "left": pm.left,
            "right": pm.right
        });
    });

    isSticky$
    // when isSticky$ is false...
    .filterBy(isSticky$.map(function (b) {
        return !b;
    }))
    // unstick the nav
    .onValue(unStickIt);

    function unStickIt() {
        (0, _jquery2.default)(element).find("nav").css({
            "position": "relative",
            "top": "auto",
            "left": "auto",
            "right": "auto"
        });
    }

    // a function to add/remove the sticky behavior
    function toggleStickyNav(status) {
        isSticky$.emit(status);
    }

    return {
        toggleStickyNav: toggleStickyNav,
        isSticky$: isSticky$
    };
}

// return the id and top offset of the chapter, relative to the document
function getChapterPositions() {
    var chapters = (0, _jquery2.default)(".chapter").map(function (i, chapter) {
        return {
            id: (0, _jquery2.default)(chapter).attr("id"),
            top: (0, _jquery2.default)(chapter).offset().top
        };
    }).get();

    return chapters;
}

// this will be updated once we init the nav
var scrollBodyTo = exports.scrollBodyTo = function scrollBodyTo() {};

/**
 * Attach sticky watcher to nav
 * @return {Stream} stream of navHeight values
 *                 (it might change if the user resizes their browser and the nav wraps)
 */
function initNav() {

    // make the nav sticky
    var _attachStickyWatcherT = attachStickyWatcherToNav({
        element: (0, _jquery2.default)(".nav-holder").get(0)
    }),
        toggleStickyNav = _attachStickyWatcherT.toggleStickyNav,
        isSticky$ = _attachStickyWatcherT.isSticky$;

    // measure the navHeight and set the height of the holder
    // this is because it will be position fixed when it's scrolls,
    // so the nav-holder will maintain the space


    var navHeight$ = (0, _common.toPropertyFromResize)(measureNav);

    // add smooth scroll to nav links
    (0, _jquery2.default)("nav a").on("click", function (e, el) {
        e.preventDefault();
        var scrollTo = (0, _jquery2.default)((0, _jquery2.default)(this).attr("href"));

        if (scrollTo) {
            scrollBodyTo(scrollTo.offset().top);
        }
    });

    // update the nav holder height
    _kefir2.default.combine([navHeight$, isSticky$]).onValue(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            navHeight = _ref4[0],
            isSticky = _ref4[1];

        (0, _jquery2.default)(".nav-holder").height(navHeight);

        // redefine this function to reflect the new navHeight
        exports.scrollBodyTo = scrollBodyTo = function scrollBodyTo(top) {
            var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 750;

            (0, _jquery2.default)("html, body").stop().animate({
                scrollTop: top - (isSticky ? navHeight : 0)
            }, duration);
        };
    });

    // remove the sticky nav on small windows
    (0, _addBreakpointHandlers2.default)({
        onSmall: function onSmall() {
            return toggleStickyNav(false);
        },
        onMedium: function onMedium() {
            return toggleStickyNav(true);
        },
        onLarge: function onLarge() {
            return toggleStickyNav(true);
        }
    });

    // stream of chapter positions
    var chapterPositions$ = (0, _common.toPropertyFromResize)(getChapterPositions);

    // watch the scroll to determine what chapter we're on
    _kefir2.default.combine([_common.scroll$, chapterPositions$, navHeight$]).onValue(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 3),
            scroll = _ref6[0],
            chapterPositions = _ref6[1],
            navHeight = _ref6[2];

        // how far above the chapter to be considered in it
        var offset = 100;

        var currentChapter = chapterPositions.map(function (chapter) {
            return Object.assign({}, chapter, { distance: scroll + navHeight - chapter.top + offset });
        }).reduce(function (closest, chapter) {
            // -1 because of rounding (could be -0.5)
            return chapter.distance > -1 && chapter.distance < closest.distance ? chapter : closest;
        }, { distance: Infinity });

        (0, _jquery2.default)("nav a").each(function (i, a) {
            var hrefId = (0, _jquery2.default)(a).attr("href").replace("#", "");
            (0, _jquery2.default)(a).toggleClass("is-current", hrefId === currentChapter.id);
        });
    });

    // return the navHeight so others can use it
    return navHeight$;
}

},{"./Kefir.emitter.js":7,"./addBreakpointHandlers.js":8,"./common.js":9,"jquery":"jquery","kefir":"kefir"}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = initPage;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _initStickyViz = require("./initStickyViz.js");

var _initStickyViz2 = _interopRequireDefault(_initStickyViz);

var _initNav = require("./initNav.js");

var _initNav2 = _interopRequireDefault(_initNav);

var _addBreakpointHandlers = require("./addBreakpointHandlers.js");

var _addBreakpointHandlers2 = _interopRequireDefault(_addBreakpointHandlers);

var _createPopup = require("./createPopup.js");

var _createPopup2 = _interopRequireDefault(_createPopup);

var _createModal = require("./createModal.js");

var _createModal2 = _interopRequireDefault(_createModal);

var _common = require("./common.js");

var _CalloutBox = require("../components/CalloutBox.jsx");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initPage() {

    /** init expandable callout boxes **/
    (0, _CalloutBox.attachCalloutBoxToDom)({
        selector: ".js-expandable-box",
        // trigger a page reflow while it animates. This ensures that the
        // sticky vizs are correct while we <animate></animate>
        onAnimationFrame: function onAnimationFrame() {
            return _common.reflow$.emit("location profile expanded/collapsed!");
        }
    });

    /** init non-expandable callout boxes **/
    (0, _CalloutBox.attachCalloutBoxToDom)({
        selector: ".js-callout-box",
        expandable: false
    });

    /** social icon links */
    // const scorecardUrl = "http://www.commonwealthfund.org/interactives/2016/jul/local-scorecard/";
    var scorecardUrl = (0, _jquery2.default)("meta[property='og:url']").attr("content");

    // https://dev.twitter.com/web/tweet-button/web-intent
    (0, _jquery2.default)(".js-twitter-link").each(function (i, a) {
        var text = "Aiming Higher: The 2017 Scorecard on State Health System Performance";
        (0, _jquery2.default)(a).attr("href", "https://twitter.com/intent/tweet?text=" + encodeURIComponent(text) + "&url=" + encodeURIComponent(scorecardUrl));
    });

    // https://developers.facebook.com/docs/plugins/share-button#configurator
    // https://developers.facebook.com/docs/sharing/webmasters#markup
    (0, _jquery2.default)(".js-facebook-link").each(function (i, a) {
        (0, _jquery2.default)(a).attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + scorecardUrl);
    });

    // https://developer.linkedin.com/docs/share-on-linkedin
    (0, _jquery2.default)(".js-linkedin-link").each(function (i, a) {
        var title = "Aiming Higher: The 2017 Scorecard on State Health System Performance";
        var summary = "Results from the Commonwealth Fund Scorecard on State Health System Performance";
        (0, _jquery2.default)(a).attr("href", "https://www.linkedin.com/shareArticle?url=" + scorecardUrl + "&title=" + title + "&summary=" + summary + "&mini=true");
    });

    /** init modal links **/
    (0, _jquery2.default)(".js-modal").each(function (i, modal) {
        var html = (0, _jquery2.default)(modal).find(".js-modal-html");

        (0, _jquery2.default)(modal).on("click", function () {
            (0, _createModal2.default)({
                html: html,
                aspectRatio: 3 / 4 // 3/4 for the chart links
            });
        });
    });

    /** init footnote popup actions **/
    (0, _jquery2.default)(".js-footnote").each(function (i, footnote) {

        (0, _jquery2.default)(footnote).removeClass("js-footnote").addClass("footnote");

        // grab the html and remove the popup content from the DOM
        var html = (0, _jquery2.default)(footnote).find(".js-footnote__popup").remove();

        var trigger = (0, _jquery2.default)(footnote).find(".js-footnote__trigger").removeClass("js-footnote__trigger").addClass("footnote__trigger");

        trigger.on("click", function (e) {
            e.preventDefault();
            var offsets = trigger.offset();
            var positionInWindow = offsets.top - (0, _jquery2.default)(window).scrollTop();
            var windowHeight = (0, _jquery2.default)(window).height();
            var showOnTop = positionInWindow > windowHeight / 2;

            var popupConfig = {
                html: html,
                top: offsets.top + trigger.height() / 2,
                left: offsets.left + trigger.width() / 2,
                offset: -trigger.height() / 2,
                triangle: showOnTop ? "bottom" : "top"
            };

            (0, _createPopup2.default)(popupConfig);
        });
    });

    /** init sticky navigation **/
    // returns a stream of navHeight (it might change when the user resizes)
    var navHeight$ = (0, _initNav2.default)();

    /** attach the sticky viz watchers **/
    var toggleFns = (0, _jquery2.default)(".viz-section__viz-holder").map(function (i, viz) {
        // return the toggle function for this sticky
        return (0, _initStickyViz2.default)({
            element: viz,
            topOffset$: navHeight$
        });
    }).get();

    function sizeNonStickyVizBox($el) {
        $el.closest(".viz-section").css("min-height", $el.height());
    }

    function sizeNonStickyBoxes() {
        (0, _jquery2.default)(".viz-section__not-sticky").each(function () {
            sizeNonStickyVizBox((0, _jquery2.default)(this));
        });
    }

    (0, _jquery2.default)(window).on("resize", function () {
        sizeNonStickyBoxes();
    });

    sizeNonStickyBoxes();

    /**
     * @param  {Boolean} enable: true to enable stickies, false to disable
     */
    function toggleStickies(enable) {

        // HACK * always emit false if this is ipad/safari
        if ((0, _jquery2.default)("html").hasClass("ipad") && (0, _jquery2.default)("html").hasClass("safari")) {
            enable = false;
            (0, _jquery2.default)(".chapter").css({
                "max-width": "600px",
                "margin": "auto"
            });

            (0, _jquery2.default)("body").addClass("is-stacked");
        }

        (0, _jquery2.default)("body").toggleClass("sticky", enable);

        // add or remove viz stickies
        toggleFns.forEach(function (toggle) {
            return toggle(enable);
        });

        // alert everyone that we need to remeasure the DOM
        _common.reflow$.emit("toggling stickies");
    }

    /** add breakpoints handers to toggle the sticky vizs **/
    (0, _addBreakpointHandlers2.default)({
        onSmall: function onSmall() {
            return toggleStickies(false);
        },
        onMedium: function onMedium() {
            return toggleStickies(false);
        },
        onLarge: function onLarge() {
            return toggleStickies(true);
        }
    });

    /** Attach hander for "Go to State Page" button */
    (0, _jquery2.default)(document).ready(function () {
        (0, _jquery2.default)(".js-state-select").change(function (e) {
            var url = (0, _jquery2.default)(".js-state-select option:selected").attr("data-url");
            (0, _jquery2.default)(".js-goto-state-page").attr("href", url);
        });

        // fire change even to initialize it on the first load
        (0, _jquery2.default)(".js-state-select").change();
    });
}

},{"../components/CalloutBox.jsx":1,"./addBreakpointHandlers.js":8,"./common.js":9,"./createModal.js":10,"./createPopup.js":11,"./initNav.js":12,"./initStickyViz.js":14,"jquery":"jquery"}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.maxVizHeight$ = undefined;
exports.default = initStickyViz;

var _kefir = require("kefir");

var _kefir2 = _interopRequireDefault(_kefir);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _common = require("./common.js");

var _initNav = require("./initNav.js");

var _KefirEmitter = require("./Kefir.emitter.js");

var _KefirEmitter2 = _interopRequireDefault(_KefirEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// distance from the top to push the viz down
var STICKY_PADDING = 10;

// **NOTE** this should match the percentage in viz-section.scss
var VIZ_WIDTH = 0.6;

// true/false if this viz is sticky
var isSticky$ = (0, _KefirEmitter2.default)();

// calculate the space from the sticky nav to the bottom of the viewport
var maxVizHeight$ = exports.maxVizHeight$ = (0, _common.toPropertyFromResize)(_initNav.measureNav).map(function (navHeight) {
    return window.innerHeight - navHeight - STICKY_PADDING;
}).combine(isSticky$, function (maxVizHeight, isSticky) {
    return isSticky ? maxVizHeight : Infinity;
}).toProperty(function () {
    return Infinity;
}); // start with Infinity


/**
 * initStickyViz: function to add sticky behaviour to a viz
 * @param  {[type]} {element    [description]
 * @param  {Number} topOffset$: stream of values for an offset from the top of the viewport to put the viz
 * @return {[type]}             [description]
 */
function initStickyViz(_ref) {
    var element = _ref.element,
        topOffset$ = _ref.topOffset$;


    var position$ = (0, _common.createPositionStream)({ element: element });

    // combine the position stream, the topOffset stream, and the maxHeight
    var shouldUpdate$ = _kefir2.default.combine([position$, topOffset$, maxVizHeight$], function (position, topOffset, maxHeight) {
        return Object.assign({}, position, {
            maxHeight: maxHeight,
            topOffset: topOffset + STICKY_PADDING
        });
    });

    shouldUpdate$
    // only do this if it's sticky
    .filterBy(isSticky$)
    // update the dom with our measurements when either of those streams emit
    .onValue(function (_ref2) {
        var scroll = _ref2.scroll,
            parentMeasures = _ref2.parentMeasures,
            elementMeasures = _ref2.elementMeasures,
            topOffset = _ref2.topOffset,
            maxHeight = _ref2.maxHeight;


        var pm = parentMeasures;
        var em = elementMeasures;

        // where the user is scrolled in relation to the parent container
        var above = scroll + topOffset < pm.top;
        var below = scroll + topOffset > pm.bottom - em.height;
        var fixed = !above && !below;

        // center might be offset, eg 70/30
        var textWidthPercentage = 100 * (1 - VIZ_WIDTH) + "%";
        var textWidthAbsolute = pm.width * (1 - VIZ_WIDTH);

        (0, _jquery2.default)(element).css({
            "position": fixed ? "fixed" : "absolute",
            "top": above ? "0px" : fixed ? topOffset + "px" : "auto",
            "right": fixed ? pm.vizOnLeft ? pm.right + textWidthAbsolute + "px" : pm.right + "px" : pm.vizOnLeft ? textWidthPercentage : "0",
            "bottom": below ? "0" : "auto",
            "left": fixed ? pm.vizOnLeft ? pm.left + "px" : pm.left + textWidthAbsolute + "px" : pm.vizOnLeft ? "0" : textWidthPercentage,
            // if the user is on a small screen, make the viz scrollable while it's fixed
            "max-height": fixed ? maxHeight + "px" : "none"
        });
    });

    isSticky$
    // when isSticky$ is false...
    .filterBy(isSticky$.map(function (b) {
        return !b;
    }))
    // unstick the nav
    .onValue(unStickIt);

    function unStickIt() {
        (0, _jquery2.default)(element).css({
            "position": "relative",
            "top": "auto",
            "right": "auto",
            "bottom": "auto",
            "left": "auto",
            // don't restrict max height when not sticky
            "max-height": "none"
        });
    }

    // a function to add/remove the stickyIt behavior
    function toggleVizSticky(status) {
        // update the stream
        isSticky$.emit(status);
    }

    // return this function so the user can toggle it as needed.
    return toggleVizSticky;
}

},{"./Kefir.emitter.js":7,"./common.js":9,"./initNav.js":12,"jquery":"jquery","kefir":"kefir"}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleSource = simpleSource;
exports.zipHrrSource = zipHrrSource;
exports.createTypeAhead = createTypeAhead;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

require("typeahead.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.jquery = _jquery2.default;
function simpleSource(accessor, options) {
  return function findMatches(q, cb) {
    var testOption = _ramda2.default.compose(_ramda2.default.test(new RegExp(q, "i")), accessor);
    cb(_ramda2.default.filter(testOption, _ramda2.default.values(options)));
  };
}

function zipHrrSource(hrrs, zips) {

  var normalMatch = simpleSource(function (hrr) {
    return hrr.name;
  }, hrrs);

  return function findMatches(q, cb) {

    // Match zipcode
    var zipMatch = zips[q];

    if (zipMatch) {
      cb([hrrs[zipMatch.hrr]]);
    } else {
      normalMatch(q, cb);
    }
  };
}

function createTypeAhead(selector, labelKey, source, handleSelected) {

  // blur the input on touch away
  function handleTouchAway(e) {
    if (!(0, _jquery2.default)(e.target).closest(".tt-menu").length) {
      closeTypeahead();
    }
  }

  function closeTypeahead() {
    (0, _jquery2.default)(selector).removeClass("tt-open");
    // this blur is important on touch devices
    (0, _jquery2.default)(selector).blur();
    window.removeEventListener("touchstart", handleTouchAway, true);
  }

  var typeaheadValue = "";

  (0, _jquery2.default)(selector).typeahead({
    hint: true,
    highlight: true,
    minLength: 0
  }, {
    displayKey: labelKey,
    limit: 500,
    source: source
  }).on("typeahead:select", function (e, suggestion, dataset) {
    handleSelected(suggestion);
  }).on("typeahead:open", function (e) {
    (0, _jquery2.default)(selector).addClass("tt-open");
    window.addEventListener("touchstart", handleTouchAway, true);

    // grab the value so we can restore it later if needed
    // for some reason $(selector).typeahead("val") doesn't work
    // even though the docs say it should...
    typeaheadValue = (0, _jquery2.default)(this).val();

    // clear the selection so the user can choose something else
    (0, _jquery2.default)(selector).typeahead("val", "");
  }).on("typeahead:close", function (e) {

    // restore the value if nothing else was selected
    if ((0, _jquery2.default)(this).val() === "" && typeaheadValue) {
      (0, _jquery2.default)(selector).typeahead("val", typeaheadValue);
    }

    typeaheadValue = "";

    closeTypeahead();
  });

  return {
    setValue: function setValue(val) {
      // if the user set this value, save it
      typeaheadValue = val;
      (0, _jquery2.default)(selector).typeahead("val", val);
    }
  };
}

},{"jquery":"jquery","ramda":"ramda","typeahead.js":"typeahead.js"}],16:[function(require,module,exports){
"use strict";

function sniff() {
    var verzApp;
    this.version = "1.2", this.browserType, this.browserVersion, this.mobile, this.browserVersionExtended = null;
    for (var e, i = !1, t = navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/iPhone|iPad|iPod/i) || navigator.userAgent.match(/Opera Mini/i) || navigator.userAgent.match(/IEMobile/i) || null, s = navigator.appName, n = navigator.userAgent, r = n.match(/(opera|chrome|safari|firefox|msie|trident|edge)\/?\s*(\.?\d+(\.\d+)*)/i), o = n.match(/(opera|chrome|safari|firefox|msie|trident|edge)\/?\s*(\.?\d+(\.\d+)*)/gi), a = 0; a < o.length; a++) {
        if (o[a].toLowerCase().indexOf("edge") >= 0) {
            var d = o[a].split("/"),
                m = d[0].toLowerCase(),
                f = d[1];
            i = !0;
        }
    }if (!i) {
        r && null != (e = n.match(/version\/([\.\d]+)/i)) && (r[2] = e[1]), r = r ? [r[1], r[2]] : [s, navigator.appVersion, "-?"];
        var m = r[0].toLowerCase(),
            f = r[1];
        "trident" == r[0].toLowerCase() && (m = "msie", f = n.match(/(rv)\:?(\.?\d+(\.\d+)*)/i), verzApp = f[0].split(":"), f = f[1]);
    }
    this.mobile = t, this.browserType = m, this.browserVersion = parseInt(f), this.browserVersionExtended = f;
}
var sniff = new sniff();
"undefined" != typeof document.documentElement.classList ? (document.documentElement.classList.add(sniff.browserType), document.documentElement.classList.add("v" + sniff.browserVersion), null != sniff.mobile && document.documentElement.classList.add(sniff.mobile.toString().toLowerCase())) : (document.documentElement.className += " " + sniff.browserType + " v" + sniff.browserVersion, null != sniff.mobile && (document.documentElement.className += " " + sniff.mobile.toString().toLowerCase()));

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * if this popup is outside of it's parent, nudge it back in
 * @param  {element} popup: DOM elmenet of the popup to be placed
 * @param  {number} top: The top coordinate of where the popup should point
 * @param  {number} left: The left coordinate of where the popup should point
 * @param  {number} offset: an offet to be added to top/bottom or left/right
 * @param  {string} triangle: "top", "right", "bottom", or "left"
 * @param  {number} triangleSize: used to calculate the position
 * @param  {boolean} flipToContain: will flip the popup if it goes outside the parent container
 * @return {object} {
 *     realTop       : with no offset adjustment, the popup should go here, based on triangleSide
 *     realLeft      : ^^
 *     popupTop      : with adjustment when the popup butts up agains the parent
 *     popupLeft     : ^^
 *     overflow      : "top", "right", "bottom", "left".  Positive numbers are overflows
 *     triangleOffset: Amount the triangle needs to move to be on the dot, relative from 50%
 *     triangleSide  : Will be the same as passed in triangle, unless it fliped via flipToContain
 * }
 * use popupTop, popupLeft, and triangleOffset to position the popup
 */
function calculatePopupOffsets(_ref) {
    var popup = _ref.popup,
        top = _ref.top,
        left = _ref.left,
        _ref$offset = _ref.offset,
        offset = _ref$offset === undefined ? 0 : _ref$offset,
        _ref$triangle = _ref.triangle,
        triangle = _ref$triangle === undefined ? "bottom" : _ref$triangle,
        triangleSize = _ref.triangleSize,
        _ref$flipToContain = _ref.flipToContain,
        flipToContain = _ref$flipToContain === undefined ? false : _ref$flipToContain;


    // make a copy of this
    var triangleSide = triangle;

    // get the width and height of this popup from the DOM
    var width = popup.offsetWidth;
    var height = popup.offsetHeight;

    // get the width/height of the parent container div
    var parent = popup.parentNode;
    var parentWidth = parent.clientWidth;
    var parentHeight = parent.offsetHeight; // client height of body will only be the viewport height

    // common calculations
    var popupOnTop = top - height - triangleSize + offset;
    var popupOnBottom = top + triangleSize - offset;
    var popupOnLeft = left - width - triangleSize + offset;
    var popupOnRight = left + triangleSize - offset;

    // calculate where the top of the popup should be based on top/left
    var realTop = triangleSide === "bottom" ? popupOnTop : triangleSide === "top" ? popupOnBottom : top - height / 2; //  left or right

    var realLeft = triangleSide === "right" ? popupOnLeft : triangleSide === "left" ? popupOnRight : left - width / 2; // center

    // the amounts that this popup is outside of it's parent.
    var overflow = {
        top: -realTop,
        right: -(parentWidth - (realLeft + width)),
        bottom: -(parentHeight - (realTop + height)),
        left: -realLeft
    };

    // calculate where the popup should go
    // start with popupLeft as realLeft before nudging
    var popupTop = realTop;
    var popupLeft = realLeft;
    var triangleOffset = 0;

    // if there is an overflow on the right, adjust the popup and triangle position
    if (overflow.right > 0) {
        if (triangleSide === "top" || triangleSide === "bottom") {
            popupLeft = realLeft - overflow.right;
            triangleOffset = overflow.right;
        }

        // for left, flip the popup
        if (triangleSide === "left" && flipToContain) {
            triangleSide = "right";
            popupLeft = popupOnLeft;
        }
    }

    // if there is an overflow on the left, adjust the popup and triangle position
    if (overflow.left > 0) {
        if (triangleSide === "top" || triangleSide === "bottom") {
            popupLeft = realLeft + overflow.left;
            triangleOffset = -overflow.left;
        }

        // for right, flip the popup
        if (triangleSide === "right" && flipToContain) {
            triangleSide = "left";
            popupLeft = popupOnRight;
        }
    }

    // if there is an overflow on the bottom
    if (overflow.bottom > 0) {
        // for left/right, butt the popup against the bottom
        if (triangleSide === "left" || triangleSide === "right") {
            popupTop = realTop - overflow.bottom;
            triangleOffset = overflow.bottom;
        }
        // for top, flip the popup
        if (triangleSide === "top" && flipToContain) {
            triangleSide = "bottom";
            popupTop = popupOnTop;
        }
    }

    // if there is an overflow on the top
    if (overflow.top > 0) {

        if (triangleSide === "left" || triangleSide === "right") {
            popupTop = realTop + overflow.top;
            triangleOffset = -overflow.top;
        }

        // for bottom, flip the popup
        if (triangleSide === "bottom" && flipToContain) {
            triangleSide = "top";
            popupTop = popupOnBottom;
        }
    }

    // return all the measurements
    return {
        realTop: realTop, realLeft: realLeft, popupTop: popupTop, popupLeft: popupLeft, overflow: overflow, triangleOffset: triangleOffset, triangleSide: triangleSide
    };
}

exports.default = calculatePopupOffsets;

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = collapsibleScale;

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _d = require("d3");

var _d2 = _interopRequireDefault(_d);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function collapsibleScale() {

  var domain = void 0;
  var positions = void 0;
  var activeLoc = void 0;
  var locationHeight = 9;

  function locHeight(loc) {
    if (activeLoc) {
      return loc === activeLoc ? domain.length + locationHeight : locationHeight - 1;
    } else {
      return locationHeight;
    }
  }

  function getPosition(activeLocId) {
    return _ramda2.default.reduce(function (accum, locId) {
      var val = accum + locHeight(locId);
      if (locId === activeLocId) {
        return _ramda2.default.reduced(val - locHeight(locId));
      }
      return val;
    }, 0, domain);
  }

  function update() {
    positions = _ramda2.default.map(getPosition, _ramda2.default.indexBy(_ramda2.default.identity, domain));
  }

  var self = function self(locId) {

    if (typeof positions !== "undefined") {
      return positions[locId];
    }
  };

  self.domain = function (d) {
    if (!d) {
      return domain;
    }
    domain = d;
    update();
    return self;
  };

  self.range = function () {
    return _ramda2.default.compose(_ramda2.default.sort(_d2.default.ascending), _ramda2.default.values)(positions);
  };

  self.height = function () {
    return _d2.default.max(_ramda2.default.values(positions)) + locHeight(_ramda2.default.last(domain));
  };

  self.locationHeight = function () {
    return locationHeight;
  };

  self.activeLocationHeight = function () {
    return domain.length + locationHeight;
  };

  self.activeLoc = function (loc) {
    activeLoc = loc;
    update();
    return self;
  };

  self.totalHeight = function () {
    return domain.length * locationHeight;
  };

  self.rangeTop = function () {
    return self(_ramda2.default.head(domain));
  };

  self.rangeMiddle = function () {
    return self.height() / 2 + self(domain[0]);
  };

  self.rangeBottom = function () {
    var last = _ramda2.default.last(domain);
    return self(last) + locHeight(last);
  };

  return self;
}

},{"d3":"d3","ramda":"ramda"}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moveToFront = moveToFront;
exports.moveToBack = moveToBack;
function moveToFront(selection) {
  return selection.each(function () {
    this.parentNode.appendChild(this);
  });
}

function moveToBack(selection) {
  return selection.each(function () {
    var firstChild = this.parentNode.firstChild;
    if (firstChild) {
      this.parentNode.insertBefore(this, firstChild);
    }
  });
}

},{}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createLocationOverall;

var _d = require("d3");

var _d2 = _interopRequireDefault(_d);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _reselect = require("reselect");

var _createPopup = require("../page/createPopup.js");

var _createPopup2 = _interopRequireDefault(_createPopup);

var _core = require("../data/core.js");

var core = _interopRequireWildcard(_core);

var _compare = require("../data/compare.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createLocationOverall(initialState) {

    // defaults, and this object will hold the previous state after setState
    var prevState = {
        selector: "",
        width: 500,
        indicators: {},
        locations: {},
        cleanData: {},
        selectedDimension: Object.keys(core.dimensionNames)[0],
        afterSlide: function afterSlide() {}
    };

    // merge the initial state in with the default state
    var state = Object.assign({}, prevState, initialState);

    function setState(newState) {
        // copy the old state into prevState
        prevState = Object.assign({}, state);

        Object.assign(state, newState);

        update();
    }

    var popup = (0, _createPopup2.default)({
        container: state.selector,
        offset: 0,
        triangle: "top",
        isHidden: true,
        closeBtn: false
    });

    var rootElement = _d2.default.select(state.selector);

    var compareStatus = (0, _compare.compare)(_ramda2.default.compose(_ramda2.default.prop(_ramda2.default.__, core.statusOrder), function (d) {
        return d.change.status;
    }), _compare.descending);

    var compareChangeMagnitude = (0, _compare.compare)(function (d) {
        return d.change.changePct;
    }, _compare.descending);

    var compareHasChange = (0, _compare.compare)(function (d) {
        return d.change.hasChange;
    }, _compare.ascending);

    var compareStatusThenChangeMagnitude = (0, _compare.composeComparators)([compareStatus, compareChangeMagnitude, compareHasChange]);

    var overallSummaryForIndicator = _ramda2.default.curry(function (locations, data, indicator) {
        return {
            indId: indicator.id,
            locations: _ramda2.default.compose(_ramda2.default.sort(compareStatusThenChangeMagnitude), _ramda2.default.map(function (loc) {
                return {
                    locId: loc.id,
                    change: {
                        changePct: core.directionCorrectedPercentChange(indicator, data[indicator.id][loc.id]),
                        status: core.status(data[indicator.id][loc.id]),
                        hasChange: core.hasChangeData(data[indicator.id][loc.id])
                    },
                    data: data[indicator.id][loc.id]
                };
            }), _ramda2.default.filter(core.notUsLocation), _ramda2.default.values)(locations)
        };
    });

    var transformRawData = (0, _reselect.createSelector)(function (state) {
        return state.locations;
    }, function (state) {
        return state.indicators;
    }, function (state) {
        return state.cleanData;
    }, function (locations, indicators, cleanData) {
        return _ramda2.default.compose(_ramda2.default.map(_ramda2.default.map(overallSummaryForIndicator(locations, cleanData))), _ramda2.default.groupBy(function (i) {
            return i.dimension;
        }), _ramda2.default.filter(core.isNotOverallIndicator), _ramda2.default.filter(core.indicatorHasHistoricalData(cleanData)), _ramda2.default.values)(indicators);
    });

    function changeEndPoints(ind) {

        var groups = _ramda2.default.groupBy(function (x) {
            return x.change.status;
        }, ind.locations);

        var improved = groups["improved"] ? [0, groups["improved"].length] : [0, 0],
            steady = groups["steady"] ? [improved[1], improved[1] + groups["steady"].length] : [improved[1], improved[1]],
            worse = groups["worse"] ? [steady[1], steady[1] + groups["worse"].length] : [steady[1], steady[1]];

        return {
            indId: ind.indId,
            range: [0, worse[1]],
            bars: [{ type: "improved", range: improved }, { type: "steady", range: steady }, { type: "worse", range: worse }],
            locations: ind.locations
        };
    }

    var xScale = _d2.default.scale.linear();

    function update() {

        var overallData = transformRawData(state);

        var span = function span(x) {
            return x[1] - x[0];
        };
        var indicatorName = function indicatorName(d) {
            return state.indicators[d.indId].shortName;
        };
        // const improvementIndex = x => span(x.bars[0].range) - span(x.bars[2].range); // improved - worse
        var mostImprovedLocationsIndex = function mostImprovedLocationsIndex(x) {
            return span(x.bars[0].range);
        };
        // const improvementIndexComparator = compare(improvementIndex, descending);
        var mostImprovedLocationsComparator = (0, _compare.compare)(mostImprovedLocationsIndex, _compare.descending);
        var nameComparator = (0, _compare.compare)(indicatorName, _compare.ascending);
        var overallImprovementComparator = (0, _compare.composeComparators)([mostImprovedLocationsComparator, nameComparator]);

        var endPoints = _ramda2.default.compose(_ramda2.default.map(_ramda2.default.sort(overallImprovementComparator)), _ramda2.default.map(_ramda2.default.map(changeEndPoints)))(overallData);

        xScale.range([2, state.width - 2]).domain(endPoints["ACCESS"][0].range);

        var dimensionGroups = rootElement.selectAll("div.dimension").data(_ramda2.default.keys(endPoints), _ramda2.default.identity);

        var dimensionGroupsEnter = dimensionGroups.enter().append("div").attr("class", "dimension");
        dimensionGroups.exit().remove();

        dimensionGroupsEnter.append("div").attr("class", "dimension-label").text(function (d) {
            return core.dimensionNames[d];
        }).on("click", function (d, i) {
            var selectedDimension = state.selectedDimension === d ? null : d;
            setState({ selectedDimension: selectedDimension });
        });

        // accordion for dimension indicators
        if (prevState.selectedDimension !== state.selectedDimension) {

            dimensionGroups.each(function (d, i) {
                var isSelected = state.selectedDimension === d;

                isSelected ? (0, _jquery2.default)(this).find(".indicators").slideDown(250, state.afterSlide) : (0, _jquery2.default)(this).find(".indicators").slideUp(250, state.afterSlide);

                (0, _jquery2.default)(this).toggleClass("is-expanded", isSelected);
            });
        }

        // make indicators
        dimensionGroupsEnter.append("div").attr("class", "indicators")
        // hide all but the first dimension
        .style({ "display": function display(d, i) {
                return i === 0 ? "block" : "none";
            } });

        var indicators = dimensionGroups.selectAll(".indicators");

        var indicatorGroups = indicators.selectAll("div.indicator").data(function (g) {
            return endPoints[g];
        }, function (d) {
            return d.indId;
        });

        var indicatorEnter = indicatorGroups.enter().append("div").attr("class", "indicator");
        indicatorGroups.exit().remove();

        indicatorEnter.append("div").attr({ "class": "indicator-label" }).text(function (d) {
            return state.indicators[d.indId].shortName;
        });
        indicatorEnter.append("svg");

        indicatorGroups.select("svg").attr("width", state.width).attr("height", 20);

        var bars = indicatorGroups.select("svg").selectAll("rect.status").data(function (g) {
            return g.bars;
        }, function (d) {
            return d.type;
        });

        bars.enter().append("rect").attr("class", "status");
        bars.exit().remove();

        var steadySpacing = 10;

        bars.attr("class", function (d) {
            return "status " + d.type;
        }).attr("x", function (d) {
            return xScale(d.range[0]) + (d.type === "steady" ? steadySpacing / 2 : 0);
        }).attr("width", function (d) {
            return xScale(d.range[1]) - xScale(d.range[0]) - (d.type === "steady" ? steadySpacing : 0);
        }).attr("y", 6).attr("height", 8).attr("rx", function (d) {
            return 4;
        }).attr("ry", function (d) {
            return 4;
        });

        var hoverBars = indicatorGroups.select("svg").selectAll("rect.hover-target").data(function (g) {
            return g.bars;
        }, function (d) {
            return d.type;
        });

        function selectBar(d) {

            var parentData = _d2.default.select(this.parentNode).datum(),
                indicator = state.indicators[parentData.indId];

            // getting the position of the .indicator (i don't think you can get the position() of an svg element)
            var parent = (0, _jquery2.default)(this).closest(".indicator");
            var yPosition = parent.position().top + parent.height();

            var xPadding = (0, _jquery2.default)(this).closest("svg").offset().left - (0, _jquery2.default)(state.selector).offset().left;

            var targetBar = _d2.default.select((0, _jquery2.default)(this).closest("svg").find("rect.status." + d.type)[0]);

            //targetBar.addClass("active");
            targetBar.transition().duration(200).attr("y", 2).attr("rx", function (d) {
                return 8;
            }).attr("ry", function (d) {
                return 8;
            }).attr("height", 16);

            showPopUp(indicator, parentData, d, [xScale((d.range[1] - d.range[0]) / 2 + d.range[0]) - 1 + xPadding, yPosition]);
        }

        function deselectBar() {

            _d2.default.select(state.selector).selectAll("rect.status").transition().duration(200).attr("y", 6).attr("rx", function (d) {
                return 4;
            }).attr("ry", function (d) {
                return 4;
            }).attr("height", 8);

            hidePopUp();

            window.removeEventListener("touchstart", deselectBar, true);
        }

        hoverBars.enter().append("rect").attr("class", "hover-target").on("mouseenter", selectBar).on("touchstart", function (d) {
            selectBar.call(this, d);
            window.addEventListener("touchstart", deselectBar, true);
        }).on("mouseleave", deselectBar);

        hoverBars.exit().remove();

        hoverBars.attr("x", function (d) {
            return xScale(d.range[0]);
        }).attr("width", function (d) {
            return xScale(d.range[1]) - xScale(d.range[0]);
        }).attr("y", 0).attr("height", 20);
    }

    update();

    function showPopUp(ind, parentData, data, point) {

        var locationCount = data.range[1] - data.range[0],
            description = data.type === "improved" ? "improved" : data.type === "worse" ? "worsened" : data.type === "steady" ? "had little or no change*" : "";

        var note = data.type === "steady" ? "<div class='indicator-overall__popup-note'>* Includes the number of local areas with no change or without sufficient data for this subpopulation to assess change over time</div>" : "";

        var html = (0, _jquery2.default)("\n                <div class=\"indicator-overall__popup\">\n                    <span class=\"" + data.type + "\"><strong>" + locationCount + "</strong> HRRs " + description + "</span>\n                    out of " + parentData.locations.length + "\n                    " + note + "\n                </div>");

        popup.setState({
            title: "",
            html: html,
            top: point[1],
            left: point[0],
            isHidden: false
        });
    }

    function hidePopUp() {
        popup.hidePopup();
    }

    // external api
    return {
        setWidth: function setWidth(width) {
            return setState({ width: width });
        }
    };
}

},{"../data/compare.js":4,"../data/core.js":5,"../page/createPopup.js":11,"d3":"d3","jquery":"jquery","ramda":"ramda","reselect":"reselect"}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.loadVizData = loadVizData;

var _d2 = require("d3");

var _d3 = _interopRequireDefault(_d2);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var endpoints = ["data/data.json", "data/indicators.json", "data/locations.json"];

var zipCodeEndpoint = "data/zipcodes.csv";

function loadZipCodeData() {

    return new Promise(function (resolve, reject) {
        _d3.default.csv(zipCodeEndpoint).row(function (d) {
            return {
                zip: d.zip,
                hrr: +d.hrr
            };
        }).get(function (error, rows) {
            if (error) reject(error);

            resolve(_ramda2.default.indexBy(_ramda2.default.prop("zip"), rows));
        });
    });
}

function loadVizData() {

    var jsonPromises = endpoints.map(function (e) {
        return fetch(e).then(function (response) {
            return response.json();
        });
    });

    jsonPromises.push(loadZipCodeData());

    return Promise.all(jsonPromises).then(function (jsons) {
        var _jsons = _slicedToArray(jsons, 4),
            cleanData = _jsons[0],
            indicators = _jsons[1],
            locations = _jsons[2],
            zips = _jsons[3];

        return { cleanData: cleanData, indicators: indicators, locations: locations, zips: zips };
    });
}

},{"d3":"d3","ramda":"ramda"}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createLocationOverall;

var _d = require("d3");

var _d2 = _interopRequireDefault(_d);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _createPopup = require("../page/createPopup.js");

var _createPopup2 = _interopRequireDefault(_createPopup);

var _core = require("../data/core.js");

var core = _interopRequireWildcard(_core);

var _compare = require("../data/compare.js");

var _collapsibleScale = require("./collapsibleScale.js");

var _collapsibleScale2 = _interopRequireDefault(_collapsibleScale);

var _d3Extensions = require("./d3Extensions.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createLocationOverall(initialState) {

    var xPath = "M9.442,6.983l3.044-3.036A1.731,1.731,0,1,0,10.036,1.5L6.993,4.537,3.952,1.5A1.731,1.731,0,0,0,1.5,3.943l3.04,3.039L1.5,10.019a1.731,1.731,0,0,0,2.449,2.445L6.991,9.428l3.042,3.039a1.731,1.731,0,0,0,2.45-2.445Z";

    // default state
    var prevState = {
        selector: "",
        width: 0,
        height: 0,
        indicators: {},
        locations: {},
        cleanData: {},
        activeLocationId: null,
        lock: false,
        onUnlock: function onUnlock() {}
    };

    // merge the initial state in with the default state before we build the svg
    var state = Object.assign({}, prevState, initialState);

    function setState(newState) {

        // copy the state into prevState
        prevState = Object.assign({}, state);

        Object.assign(state, newState);

        // if the locked location has changed (could be back to null)
        if (!state.lock && prevState.lock) {
            state.onUnlock();
        }

        // add touch away handler if a location is open
        if (state.activeLocationId) {
            window.addEventListener("touchstart", handleTouchAwayLocation, true);
        }

        update();
    }

    var margin = {
        top: 10,
        right: 10,
        bottom: 10,
        left: 25 // room for location dot
    };

    var popup = (0, _createPopup2.default)({
        container: state.selector,
        offset: -6,
        triangle: "top",
        isHidden: true,
        closeBtn: false
    });

    var svg = _d2.default.select(state.selector).append("svg");

    // Arrow heads
    var defs = svg.append("defs");

    defs.append("marker").attr("id", "arrow-overall").attr("markerWidth", 10).attr("markerHeight", 10).attr("refX", 0).attr("refY", 2).attr("orient", "auto-start-reverse").attr("markerUnits", "strokeWidth").append("path").attr("d", "M0,0 L0,4 L3,2 z");

    defs.append("pattern").attr("id", "diagonal").attr("patternUnits", "userSpaceOnUse").attr("width", 6).attr("height", 6).append("path").attr("d", "M-1,1 l 2,-2 M 0,6 l 6,-6 M 5,7 l 4,-4");

    var g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var compareStatus = (0, _compare.compare)(_ramda2.default.compose(_ramda2.default.prop(_ramda2.default.__, core.statusOrder), function (d) {
        return d.change.status;
    }), _compare.descending);

    var compareChangeMagnitude = (0, _compare.compare)(function (d) {
        return d.change.changePct;
    }, _compare.descending);

    var compareHasChange = (0, _compare.compare)(function (d) {
        return d.change.hasChange;
    }, _compare.ascending);

    var compareStatusThenChangeMagnitude = (0, _compare.composeComparators)([compareStatus, compareChangeMagnitude, compareHasChange]);

    var overallSummaryForLocation = _ramda2.default.curry(function (indicators, data, location) {
        return {
            locId: location.id,
            medicaidExpansion: location.medicaidExpansion,
            indicators: _ramda2.default.compose(_ramda2.default.sort(compareStatusThenChangeMagnitude), _ramda2.default.map(function (ind) {
                return {
                    indId: ind.id,
                    change: {
                        changePct: core.directionCorrectedPercentChange(ind, data[ind.id][location.id]),
                        status: core.status(data[ind.id][location.id]),
                        hasChange: core.hasChangeData(data[ind.id][location.id])
                    },
                    data: data[ind.id][location.id]
                };
            }), _ramda2.default.filter(core.isNotOverallIndicator), _ramda2.default.values)(indicators)
        };
    });

    function transformRawData(locations, indicators, data) {
        return _ramda2.default.values(locations).filter(core.notUsLocation).map(overallSummaryForLocation(indicators, data));
    }

    function changeEndPoints(loc) {

        var groups = _ramda2.default.groupBy(function (x) {
            return x.change.status;
        }, loc.indicators);

        var statusKeys = ["improved-full", "improved-half", "steady", "worse-half", "worse-full"];

        // find the bar lengths for each status for the location lines
        var statuses = _ramda2.default.reduce(function (acc, statusKey) {

            var indicatorCount = groups[statusKey] ? groups[statusKey].length : 0;
            var nextTally = acc.tally + indicatorCount;

            return {
                tally: nextTally,
                bars: acc.bars.concat({
                    type: statusKey,
                    range: [acc.tally, nextTally]
                })
            };
        }, { tally: 0, bars: [] }, statusKeys);

        // sort the indicators by the statusKeys (green to red)
        var sortedIndicators = loc.indicators.sort(function (a, b) {
            var getStatusIndex = function getStatusIndex(indicator) {
                return statusKeys.indexOf(indicator.change.status);
            };
            return getStatusIndex(a) - getStatusIndex(b);
        });

        return Object.assign({}, loc, {
            range: [0, statuses.tally],
            bars: statuses.bars,
            indicators: sortedIndicators
        });
    }

    var indicatorXScale = _d2.default.scale.ordinal();

    var overallData = transformRawData(state.locations, state.indicators, state.cleanData);

    var span = function span(x) {
        return x[1] - x[0];
    };
    var locationName = function locationName(d) {
        return state.locations[d.locId].name;
    };
    var improvementIndex = function improvementIndex(x) {
        return span(x.bars[0].range) - span(x.bars[2].range);
    }; // improved - worse
    var improvedIndicators = function improvedIndicators(x) {
        return span(x.bars[0].range) + span(x.bars[1].range);
    }; // sort by most improved indicators (0 and 1, improved-full/improved-half)
    // const improvementIndexComparator = compare(improvementIndex, descending);
    var nameComparator = (0, _compare.compare)(locationName, _compare.ascending);
    var improvedIndicatorsComparator = (0, _compare.compare)(improvedIndicators, _compare.descending);
    var overallImprovementComparator = (0, _compare.composeComparators)([improvedIndicatorsComparator, nameComparator]);

    var endPoints = _ramda2.default.compose(_ramda2.default.sort(overallImprovementComparator), _ramda2.default.map(changeEndPoints), _ramda2.default.values)(overallData);

    function update() {
        var activeLocationId = state.activeLocationId;


        var yScale = (0, _collapsibleScale2.default)().domain(endPoints.map(function (d) {
            return d.locId;
        })).activeLoc(activeLocationId);

        var vizWidth = state.width - margin.left - margin.right;
        var vizHeight = yScale.totalHeight();

        var locationLineHeight = yScale.locationHeight() - 3;
        var locationDotRadius = locationLineHeight / 2;
        var locationDotArea = locationDotRadius * 2 + 3; // padding

        var locationXScale = _d2.default.scale.linear().domain(endPoints[0].range).range([0, vizWidth]);

        var columnIsExpanding = false;

        svg.attr("width", vizWidth + margin.left + margin.right).attr("height", vizHeight + margin.top + margin.bottom);

        /**
         * @param  {Array} mouse : [x, y], see https://github.com/d3/d3-selection#mouse
         * @return {Number} locationId
         */
        var findLocationAtMouse = function findLocationAtMouse(mouse) {
            return yScale.domain()[_d2.default.bisect(yScale.range(), mouse[1]) - 1] || yScale.domain()[0];
        };

        svg.on("mouseleave", function () {
            if (state.lock) {
                return;
            }
            setState({ activeLocationId: null });
        });

        g.on("mousemove", function (d, i) {
            if (columnIsExpanding || state.lock) {
                return;
            }

            var hoveredLocationId = findLocationAtMouse(_d2.default.mouse(this));

            if (hoveredLocationId === activeLocationId) {
                return;
            }

            columnIsExpanding = true;
            hidePopUp();
            setState({ activeLocationId: hoveredLocationId });
        }).on("click", function (d, i) {

            if (state.activeLocationId) {
                return;
            }

            var hoveredLocationId = findLocationAtMouse(_d2.default.mouse(this));
            setState({ activeLocationId: hoveredLocationId });
        });

        var locationGroups = g.selectAll("g.location").data(endPoints, _ramda2.default.prop("locId"));

        locationGroups.enter().append("g").attr("class", "location").append("circle").attr("class", "location-dot");

        locationGroups.exit().remove();

        locationGroups.transition().duration(100).attr("transform", function (d, i) {

            // var columnIndex = d3.select(this.parentNode).datum().column;
            return "translate(0, " + yScale(d.locId) + ")";
        }).style("opacity", function (d) {
            return d.locId === activeLocationId ? 0 : 1;
        });

        var locationDot = locationGroups.selectAll(".location-dot").attr("r", locationDotRadius).attr("cx", -locationDotArea) // move into margin
        .attr("cy", locationDotRadius).attr("opacity", function (d) {
            return d.medicaidExpansion === true ? 1 : 0;
        });

        var locationLines = locationGroups.selectAll("rect.status").data(function (d) {
            return d.bars;
        }, _ramda2.default.prop("type"));

        locationLines.enter().append("rect").attr("class", "status");
        locationLines.exit().remove();

        locationLines.attr("class", function (d) {
            return "status " + d.type;
        }).transition().attr("x", function (d) {
            return locationXScale(d.range[0]) + 1;
        }).attr("y", 0).attr("width", function (d) {
            return Math.max(0, locationXScale(d.range[1]) - locationXScale(d.range[0]) - 1);
        }).attr("height", yScale.locationHeight() - 3) // minus padding
        .attr("rx", 2).attr("ry", 2).each("end", function () {
            columnIsExpanding = false;
        });

        var activeLocationGroup = g.select("g.active-location");

        if (activeLocationId && activeLocationGroup.empty()) {
            activeLocationGroup = g.append("g").attr("class", "active-location location-label");
        } else if (!activeLocationGroup.empty() && !activeLocationId) {
            activeLocationGroup.remove();
        }

        var closeButton = g.select("path.close");

        if (closeButton.empty()) {
            closeButton = g.append("path").attr("class", "close").attr("d", xPath).attr("width", 18).attr("height", 18).style("display", "none").on("click", function () {
                setState({ lock: false });
            });
        }

        closeButton.style("display", "none");

        // let yLabelGroupLeft = g.select("g.y-label.left");
        //
        // if (yLabelGroupLeft.empty()){
        //     yLabelGroupLeft = g.append("g").attr("class", "y-label left");
        //
        //     yLabelGroupLeft.append("line")
        //         .attr("marker-start", "url(#arrow-overall)");
        //
        //     yLabelGroupLeft.append("rect")
        //         .attr("class", "background");
        //
        //     yLabelGroupLeft.append("text")
        //         .text("more improved");
        // }
        //
        // yLabelGroupLeft.select("line")
        //     .transition()
        //     .attr("x1", - 13).attr("x2", - 13)
        //     .attr("y1", 6).attr("y2", yScale.rangeBottom());
        //
        // yLabelGroupLeft.select("rect.background")
        //     .attr("x", - 18)
        //     .attr("y", yScale.rangeMiddle() - 55)
        //     .attr("width", 10)
        //     .attr("height", 110);
        //
        // yLabelGroupLeft.select("text")
        //     .transition()
        //     .attr("x", - 10)
        //     .attr("y", yScale.rangeMiddle())
        //     .attr("transform", `rotate(-90, -10, ${yScale.rangeMiddle()})`);

        // var yLabelGroupRight = g.select("g.y-label.right");
        //
        // if (yLabelGroupRight.empty()){
        //     yLabelGroupRight = g.append("g").attr("class", "y-label right");
        //
        //     yLabelGroupRight.append("line")
        //         .attr("marker-end", "url(#arrow-overall)");
        //
        //     yLabelGroupRight.append("rect")
        //         .attr("class", "background");
        //
        //     yLabelGroupRight.append("text")
        //         .text("less improved");
        // }
        //
        // yLabelGroupRight.select("line")
        //     .transition()
        //     .attr("x1", vizWidth + 13).attr("x2",vizWidth + 13)
        //     .attr("y1", 0).attr("y2", yScales[1].rangeBottom() - 6);
        //
        // yLabelGroupRight.select("rect.background")
        //     .attr("x", vizWidth + 8)
        //     .attr("y", yScales[1].rangeMiddle() - 55)
        //     .attr("width", 10)
        //     .attr("height", 110);
        //
        // yLabelGroupRight.select("text")
        //     .transition()
        //     .attr("x", vizWidth + 10)
        //     .attr("y", yScales[1].rangeMiddle())
        //     .attr("transform", `rotate(90, ${vizWidth + 10}, ${yScales[1].rangeMiddle()})`);

        // moveToFront(hoverZones);

        if (activeLocationId) {
            var label;
            var indicatorDots;
            var activeLocationDot;
            var activeIndicatorId;

            (function () {
                var activeData = _ramda2.default.find(function (d) {
                    return d.locId === activeLocationId;
                }, endPoints);

                var range = locationXScale.range();

                indicatorXScale.rangeBands(range, 0.1).domain(activeData.indicators.map(_ramda2.default.prop("indId")));

                // Label

                label = activeLocationGroup.select("text.label");


                if (label.empty()) {
                    label = activeLocationGroup.append("text").attr("class", "label");
                }

                label.attr("x", (range[1] - range[0]) / 2 + range[0]).attr("y", yScale(activeLocationId) + 14).attr("dy", "1ex").text(state.locations[activeLocationId].name);

                // Dots

                var dotHeight = 18;

                indicatorDots = activeLocationGroup.selectAll("rect.indicator-dot").data(activeData.indicators, _ramda2.default.prop("indId"));


                indicatorDots.enter().append("rect").attr("class", "indicator-dot");
                indicatorDots.exit();

                var positionDot = _ramda2.default.curry(function (active, d) {

                    var offset = active ? [-1, -2] : [0, 0];

                    return "translate(" + (indicatorXScale(d.indId) + offset[0]) + ", " + (yScale(activeLocationId) + 32 + offset[1]) + ")" + (active ? "scale(1.2)" : "");
                });

                indicatorDots.attr("x", 0).attr("y", 0).attr("rx", 4).attr("ry", 4).attr("transform", positionDot(false)).attr("width", indicatorXScale.rangeBand()).attr("height", dotHeight)
                // .attr("class", d => d.change.status) why doesn't this work??
                .classed("improved-full", function (d) {
                    return d.change.status === "improved-full";
                }).classed("improved-half", function (d) {
                    return d.change.status === "improved-half";
                }).classed("steady", function (d) {
                    return d.change.status === "steady";
                }).classed("worse-half", function (d) {
                    return d.change.status === "worse-half";
                }).classed("worse-full", function (d) {
                    return d.change.status === "worse-full";
                }).classed("na", function (d) {
                    return _ramda2.default.isNil(d.data.years[0].value);
                }).style("fill", function (d) {
                    return _ramda2.default.isNil(d.data.years[0].value) ? "url(#diagonal)" : "";
                });

                // Yellow dot
                activeLocationDot = activeLocationGroup.select(".location-dot");


                if (activeLocationDot.empty()) {
                    activeLocationDot = activeLocationGroup.append("circle").attr("class", "location-dot");
                }

                activeLocationDot.attr("r", locationDotRadius * 2).attr("cx", -locationDotArea).attr("cy", locationDotRadius + yScale(activeLocationId) + 32 - 2 + dotHeight / 2) // magic numbers from positionDot()
                .attr("fill", "#e8ba1a").attr("opacity", function (d) {
                    return activeData.medicaidExpansion === true ? 1 : 0;
                });

                // hover zone
                var indicatorDotHoverZone = g.select("rect.hover-zone.indicator");

                closeButton.attr("transform", "translate(" + (range[1] - 20) + ", " + (yScale(activeLocationId) + 6) + ")").style("display", state.lock ? "block" : "none");

                if (indicatorDotHoverZone.empty()) {
                    indicatorDotHoverZone = g.append("rect").attr("class", "hover-zone indicator");
                }

                indicatorDotHoverZone.attr("fill", "blue").attr("opacity", 1);

                indicatorDotHoverZone.attr("x", range[0]).attr("y", yScale(activeLocationId)).attr("width", range[1] - range[0]).attr("height", yScale.activeLocationHeight() - 2).on("mousemove", function () {
                    if (columnIsExpanding) {
                        return;
                    }
                    var m = _d2.default.mouse(this);
                    var indAtMouse = indicatorXScale.domain()[_d2.default.bisect(indicatorXScale.range(), m[0]) - 1] || indicatorXScale.domain()[0];

                    if (indAtMouse === activeIndicatorId) {
                        return;
                    }
                    activeIndicatorId = indAtMouse;
                    // Deactivate all indicator nodes on switch
                    activeLocationGroup.selectAll("rect.indicator-dot").attr("transform", positionDot(false));

                    // Activate just the selected node
                    var node = findIndicatorNode(activeLocationGroup, activeIndicatorId);
                    node.attr("transform", positionDot(true));

                    var xPadding = (0, _jquery2.default)(this).closest("svg").offset().left - (0, _jquery2.default)(state.selector).offset().left;
                    var top = yScale(activeLocationId) + margin.top + yScale.activeLocationHeight() / 2;
                    var offset = -1 * yScale.activeLocationHeight() / 2;
                    var triangle = top < yScale.height() / 2 ? "top" : "bottom";

                    showPopUp(state.indicators[activeIndicatorId], node.datum(), [indicatorXScale(activeIndicatorId) + indicatorXScale.rangeBand() / 2 + margin.left + xPadding, top], offset, triangle);
                }).on("mouseleave", function () {
                    var node = findIndicatorNode(activeLocationGroup, activeIndicatorId);
                    node.attr("transform", positionDot(false));
                    activeIndicatorId = null;
                    hidePopUp();
                }).on("click", function () {
                    setState({ lock: true });
                });

                (0, _d3Extensions.moveToFront)(indicatorDotHoverZone);
                (0, _d3Extensions.moveToFront)(closeButton);

                // add window click away listener
                if (state.lock) {
                    window.addEventListener("click", handleClickAway, true);
                } else {
                    window.removeEventListener("click", handleClickAway, true);
                }
            })();
        }
    }

    function findIndicatorNode(parent, indId) {
        return parent.selectAll("rect.indicator-dot").filter(function (d) {
            return d.indId === indId;
        });
    }

    function showPopUp(ind, data, point, offset, triangle) {

        var formatter = core.formatValue(ind);

        var html = (0, _jquery2.default)("\n            <div class=\"location-overall__popup\">\n                <table>\n                    <tbody>\n                    <tr>" + (!_ramda2.default.isNil(data.data.years[1].value) ? "<td><span>" + ind.years[1] + "</span> <strong class=\"" + data.change.status + "\">" + formatter(data.data.years[1].value, true) + "</strong></td>" + (!_ramda2.default.isNil(data.data.years[0].value) ? "<td><span>" + ind.years[0] + "</span> <strong>" + formatter(data.data.years[0].value, true) + "</strong></td>" : "<td><em>Historic data not available</em></td>") : "<td><em>Data not available for this location</em></td>") + "</tr>\n                    </tbody>\n                </table>\n            </div>");

        popup.setState({
            title: "<span class=\"indicator-label\">" + ind.longName + "</span>",
            html: html,
            top: point[1],
            left: point[0],
            isHidden: false,
            offset: offset,
            triangle: triangle
        });

        // replace the location touch away with the popup touch away
        window.addEventListener("touchstart", handleTouchAwayPopup, true);
        window.removeEventListener("touchstart", handleTouchAwayLocation, true);
    }

    function hidePopUp() {
        popup.hidePopup();
    }

    function handleClickAway(event) {

        var clickIsInActiveLocation = (0, _jquery2.default)(event.target).closest(".active-location").length > 0;

        if (state.activeLocationId && !clickIsInActiveLocation) {
            clearLock();
        }
    }

    // hide the popup, and listen for another touch away to hide the location
    function handleTouchAwayPopup(e) {
        if (!(0, _jquery2.default)(e.target).closest(state.selector).length) {
            hidePopUp();
            window.removeEventListener("touchstart", handleTouchAwayPopup, true);
            window.addEventListener("touchstart", handleTouchAwayLocation, true);
        }
    }

    function handleTouchAwayLocation(e) {
        if (!(0, _jquery2.default)(e.target).closest(state.selector).length) {
            clearLock();
            window.removeEventListener("touchstart", handleTouchAwayLocation, true);
        }
    }

    function clearLock() {
        setState({
            activeLocationId: null, lock: false
        });
    }

    update();

    // external api
    return {
        setWidth: function setWidth(width) {
            return setState({ width: width });
        },
        setActiveLocation: function setActiveLocation(loc) {
            return setState({ activeLocationId: loc, lock: true });
        }
    };
}

},{"../data/compare.js":4,"../data/core.js":5,"../page/createPopup.js":11,"./collapsibleScale.js":18,"./d3Extensions.js":19,"d3":"d3","jquery":"jquery","ramda":"ramda"}]},{},[6]);
